import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import classNames from 'classnames';
import _ from 'lodash';
import { Translate } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';
import Moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';
import 'react-widgets/lib/less/react-widgets.less';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Link, withRouter } from 'react-router';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Tabs, Tab, Image, Breadcrumb } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import { Selection } from '../Common/selection';
import { DetailedSelection, VirtualizedDetailedSelection } from '../Common/detailedSelection';
import { DisabledSelection } from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import ConvertItemPrice from '../Common/convertItemPrice';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import Spinner from '../Widgets/spinner';
import CustomerInfo from '../../containers/Purchase/customerInfo';
import InventoryInfo from '../../containers/Purchase/inventoryInfo';
import ConfirmActionModal from '../Common/confirmActionModal';
import TaxSelectionModal from '../Common/taxSelectionModal';
import PurchaseOrderAutoSuggest from '../Common/PurchaseOrderAutoSuggest';
import { convertLocalDate } from '../Common/cleanDates';
import BoldCashFormatter from '../Common/boldCashFormatter';
import BoldTextFormatter from '../Common/boldTextFormatter';

import { ROOT_URL, isOLG, isVAK } from '../../actions/root_url';

momentLocalizer(Moment);

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

let renderRadios = props => {
    const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label', 'col-xs-3', 'centerStyle')
    return (
        <Col xs={ 12 }>
          <Row>
            <Col xs={ 12 }>
              {props.meta.active && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
            </Col>
            <Col xs={ 5 }>
              <label className="inlineLabel" >
                <Translate value="dropship_po_detail" /><span className="asteriksReq">*</span>
              </label>
            </Col>
            <Col xs={ 1 }>
                <label className="inlineLabel radioMargin" >
                  <Input className="inlineLabel" {...props.input} type="radio" value="true"
                    checked={props.input.value === true || props.input.value === "true"}/>
                </label>
            </Col>
            <Col xs={ 2 } className="custom-col-width">
                <label className="inlineLabel radioMargin" >
                    <Translate value="yes" />
                </label>
            </Col>
            <Col xs={ 1 }>
                <label className="inlineLabel radioMargin" >
                    <Input className="inlineLabel" {...props.input} type="radio" value="false"
                      checked={props.input.value === false || props.input.value === "false"}/>
                </label>
            </Col>
            <Col xs={ 2 }>
                <label className="inlineLabel radioMargin" >
                    <Translate value="no" />
                </label>
            </Col>
          </Row>
        </Col>
    )
}

let renderTypeRadios = props => {
    return (
        <div className="form-group" id="search-product-by">
          <label className="col-xs-4 search-by-max-width">
            <Translate value="search_by" />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="ProductNum"
                checked={props.input.value === "ProductNum"}/>
              <Translate value="prod_num" />
          </label>
          <label className="col-xs-2 pl">
            <input {...props.input} type="radio" value="RefNum"
              checked={props.input.value === "RefNum"}/>
            <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="Name"
                checked={props.input.value === "Name"}/>
              <Translate value="name" />
          </label>
          <label className="col-xs-2 ml-lg" >
              <input {...props.input} type="radio" value="Description"
                checked={props.input.value === "Description"}/>
              <Translate value="description" />
          </label>
        </div>
    )
}

class PurchaseOrderForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,
            files: null,

            firstRender: false,
            firstFocus: true,

            productInfo: {},
            totalNetWeight: 0,
            totalShippingWeight: 0,
            totalPrice: 0,
            totalPriceForTax: 0,
            totalPriceForAllLines: 0,

            taxRate: 0,
            discountValue: 0,
            priceType: 'FOB',
            finalPrice: 0,
            miscCostValue: 0,
            handlingCostValue: 0,
            shippingCostValue: 0,
            adjustmentValue: 0,

            created_by: null,
            modified_by: null,
            updateTime: null,

            quantity: 0,
            CRV: 0,

            calculatedProducts: [],

            vendorInformationOpen: true,
            oneTimeScheduleOpen: true,
            purchaseInformationOpen: true,
            orderHistoryOpen: true,
            inventoryOpen: true,
            showCustomerOpen: false,
            showInventoryOpen: false,
            showPOCreatedOpen: false,
            confirmOpen: false,
            changeTaxOpen: false,

            dirty: false,
            type: 'purchaseOrder',
            orderInfo: null,

            vendorProducts: {
              rows: [],
              selectedRows: [],
              sortColumn: null,
              sortDirection: null,
              selectedIndexes: [],
            },

            productInfos: {
              rows: [],
              selectedRows: [],
              sortColumn: null,
              sortDirection: null,
              selectedIndexes: [],
            },

            rows: [],
            selectedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            selectedInventoryRow: {},

            case: null,
            quantityZero: [],
            yourOrderTableHeight: (window.innerHeight < 930) ? 350 : 350,
            yourOrderKey: 2,
            suggestValue: '',
            PdfFrameLoaded: true,
        }
        this.handleMiscCostChange = this.handleMiscCostChange.bind(this);
        this.handleShippingCostChange = this.handleShippingCostChange.bind(this);
        this.handleHandlingCostChange = this.handleHandlingCostChange.bind(this);
        this.handleDiscountChange = this.handleDiscountChange.bind(this);
        this.handleAdjustmentChange = this.handleAdjustmentChange.bind(this);
        // this.handleTaxChange = this.handleTaxChange.bind(this);
        this.handleLowestSalePriceChange = this.handleLowestSalePriceChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.openShowInventory = this.openShowInventory.bind(this);
        this.closeShowInventory = this.closeShowInventory.bind(this);
        this.openShowPOCreated = this.openShowPOCreated.bind(this);
        this.closeShowPOCreated = this.closeShowPOCreated.bind(this);
        this.openConfirm = this.openConfirm.bind(this);
        this.closeConfirm = this.closeConfirm.bind(this);
        this.openChangeTax = this.openChangeTax.bind(this);
        this.closeChangeTax = this.closeChangeTax.bind(this);
        this.selectInventoryInfo = this.selectInventoryInfo.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.moveOffFromProductsList = this.moveOffFromProductsList.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.closeShowCustomer= this.closeShowCustomer.bind(this);
        this.isDropship = this.isDropship.bind(this);
        this.isPurchaseOrder = this.isPurchaseOrder.bind(this);
        this.isPurchaseQuote = this.isPurchaseQuote.bind(this);
        this.placeNewOrder = this.placeNewOrder.bind(this);
        this.isPurchaseTemplate = this.isPurchaseTemplate.bind(this);
        // this.handleKeyPressTargetSelection = this.handleKeyPressTargetSelection.bind(this);
        // this.handleKeyPressTargetInput = this.handleKeyPressTargetInput.bind(this);
        // this.handleKeyPress = this.handleKeyPress.bind(this);
        // this.handleKeyPressMove = this.handleKeyPressMove.bind(this);
        // this.handleKeyPressMoveVendor = this.handleKeyPressMoveVendor.bind(this);
        this.redirect = this.redirect.bind(this);
        this.setAllProductQuantity = this.setAllProductQuantity.bind(this);
    }

    componentWillMount() {
      if(this.context.router.routes[1].path == "purchaseOrder/new") {
        this.props.resetCurrentPurchaseOrder();
        this.props.resetCurrentPurchaseQuote();
        this.props.resetCurrentPurchaseTemplate();
        this.props.fetchActiveVendors();
        this.props.fetchPaymentTerms();
        this.props.fetchWarehouses();
        this.props.fetchTaxRates();
        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
      }
      else if (this.context.router.routes[1].path == "purchaseOrder/:id"){
        this.props.resetCurrentPurchaseQuote();
        this.props.resetCurrentPurchaseTemplate();
        this.props.fetchTaxRates();
        const { currentPurchaseOrder, currentPurchaseQuote, currentPurchaseTemplate } = this.props;
        this.props.fetchWarehouses()
            .then(() => {
                return this.props.fetchVendors()
            })
            .then(() => {
                return this.props.fetchPaymentTerms();
            })
            .then(() => {
                // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm')
                this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
                return this.props.fetchPurchaseOrderDetail(currentPurchaseOrder.PurchaseOrder_id);
            })
            .then(() => {
                this.props.fetchVendorDetail(this.props.currentPurchaseOrderDetail && this.props.currentPurchaseOrderDetail.Vendor_id);
                this.props.fetchProductsByVendor(this.props.currentPurchaseOrderDetail && this.props.currentPurchaseOrderDetail.Vendor_id);
            })
      }
      else if(this.context.router.routes[1].path == "purchaseQuote/new") {
        this.props.resetCurrentPurchaseOrder();
        this.props.resetCurrentPurchaseQuote();
        if (this.props.currentPurchaseTemplate){
          this.props.convertTemplateToQuote(this.props.currentPurchaseTemplate.PurchaseTemplate_id);
        }
          this.props.resetCurrentPurchaseTemplate();
        this.props.fetchVendors();
        this.props.fetchPaymentTerms();
        this.props.fetchWarehouses();
        this.props.fetchTaxRates();
        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
      }
      else if (this.context.router.routes[1].path == "purchaseQuote/:id"){
        this.props.resetCurrentPurchaseOrder();
        this.props.resetCurrentPurchaseTemplate();
        this.props.fetchTaxRates();
        const { currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
        this.props.fetchWarehouses()
            .then(() => {
                return this.props.fetchVendors()
            })
            .then(() => {
                return this.props.fetchPaymentTerms();
            })
            .then(() => {
                // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
                this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
                return this.props.fetchPurchaseQuoteDetail(currentPurchaseQuote.PurchaseOrder_id);
            })
            .then(() => {
                this.props.fetchVendorDetail(this.props.currentPurchaseQuoteDetail && this.props.currentPurchaseQuoteDetail.Vendor_id);
                this.props.fetchProductsByVendor(this.props.currentPurchaseQuoteDetail && this.props.currentPurchaseQuoteDetail.Vendor_id);
            })
      }
      else if(this.context.router.routes[1].path == "purchaseTemplate/new") {
        this.props.resetCurrentPurchaseOrder();
        this.props.resetCurrentPurchaseQuote();
        this.props.resetCurrentPurchaseTemplate();
        this.props.fetchVendors();
        this.props.fetchPaymentTerms();
        this.props.fetchWarehouses();
        this.props.fetchTaxRates();
        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
      }
      else if (this.context.router.routes[1].path == "purchaseTemplate/:id"){
        this.props.resetCurrentPurchaseQuote();
        this.props.resetCurrentPurchaseOrder();
        this.props.fetchTaxRates();
        const { currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
        this.props.fetchWarehouses()
            .then(() => {
                return this.props.fetchVendors()
            })
            .then(() => {
                return this.props.fetchPaymentTerms();
            })
            .then(() => {
                // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm')
                this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
                return this.props.fetchPurchaseTemplateDetail(currentPurchaseTemplate.PurchaseTemplate_id);
            })
            .then(() => {
                this.props.fetchVendorDetail(this.props.currentPurchaseTemplateDetail && this.props.currentPurchaseTemplateDetail.Vendor_id);
                this.props.fetchProductsByVendor(this.props.currentPurchaseTemplateDetail && this.props.currentPurchaseTemplateDetail.Vendor_id);
            })
      }

      else {
        this.props.fetchVendors();
        this.props.fetchPaymentTerms();
        this.props.fetchWarehouses();
        this.props.fetchTaxRates();
        // this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        this.props.initializedPurchaseOrderForm('RefNum', 'purchaseOrderForm');
        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
      }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps, prevState) {
      if(!this.props.searchType) {
        this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
      }
      if(!this.props.isDropship) {
        this.props.setDefaultIsDropship('false', 'purchaseOrderForm');
      }
      if(!this.props.priceTypeValue) {
        this.props.setDefaultConvertItemPrice('FOB', 'purchaseOrderForm');
      }
      if(this.refs["vendor_name"] && this.state.firstFocus){
        this.refs["vendor_name"].getRenderedComponent().refs.select.focus();
        this.setState({firstFocus: false});
      }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.taxRate && nextProps.taxRate != this.props.taxRate) {
          let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
          let taxRate = (nextProps.taxRate.value >= 0) ? nextProps.taxRate.value : nextProps.taxRate;
          let taxValue = parseFloat(taxRate)*totalPriceForTax/100.0;
          taxValue = Math.round(0.0001 + taxValue * 100) / 100;
          this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
          this.setState({taxRate: nextProps.taxRate.value});
        }
        if(nextProps.products && nextProps.products != this.props.products) {
          let vendorProducts = {...this.state.vendorProducts, rows: nextProps.products };
          this.setState({vendorProducts})
        }
        if(nextProps.purchaseOrderCreated && nextProps.purchaseOrderCreated != this.props.purchaseOrderCreated) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseOrderEdited && nextProps.purchaseOrderEdited != this.props.purchaseOrderEdited) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseOrderPlaced && nextProps.purchaseOrderPlaced != this.props.purchaseOrderPlaced) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseQuoteCreated && nextProps.purchaseQuoteCreated != this.props.purchaseQuoteCreated) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseQuoteEdited && nextProps.purchaseQuoteEdited != this.props.purchaseQuoteEdited) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseTemplateCreated && nextProps.purchaseTemplateCreated != this.props.purchaseTemplateCreated) {
          this.openShowPOCreated();
        }
        if(nextProps.purchaseTemplateEdited && nextProps.purchaseTemplateEdited != this.props.purchaseTemplateEdited) {
          this.openShowPOCreated();
        }
        if(nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
          if(nextProps.taxRates && nextProps.taxRates.length != 0)
            this.setState({taxRate: 0})
        }
        if(nextProps.currentVendorDetail && nextProps.currentVendorDetail != this.props.currentVendorDetail) {
          let currentVendorDetail = nextProps.currentVendorDetail;
          this.props.setValue('purchaseOrderForm', 'PaymentTerm_id',
          (this.props.currentPurchaseOrderDetail && this.props.currentPurchaseOrderDetail.PaymentTerm_id)
          || (this.props.currentPurchaseQuoteDetail && this.props.currentPurchaseQuoteDetail.PaymentTerm_id)
          || (this.props.currentPurchaseTemplateDetail && this.props.currentPurchaseTemplateDetail.PaymentTerm_id)
          || nextProps.currentVendorDetail.PaymentTerm_id);
        }
        if(nextProps.productInformation && nextProps.productInformation != this.props.productInformation) {
          const products = this.props.products;
          const productInformation = nextProps.productInformation;
          const index = _.findIndex(products, { 'Product_id': productInformation.value || productInformation });
          if(products[index]){
            this.props.fetchProductInfo(products[index].Product_id);
            this.props.setDefaultOfForm('FOBUnitPrice', products[index].ProductCost, 'purchaseOrderForm');
            this.props.setDefaultOfForm('Weight', products[index].NetWeight, 'purchaseOrderForm');
            this.setState({ProductType: products[index].ProductType});
          }
        }
        if (nextProps.allProducts && nextProps.allProducts != this.props.allProducts) {
          let index = _.findIndex(this.props.simplifiedProducts, {'Product_id': nextProps.allProducts.value });
          if (index > -1) {
            this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
            this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseOrderForm');
          }
        }
        if(nextProps.productInfo && nextProps.productInfo != this.props.productInfo) {
          let productInfo = nextProps.productInfo;
          let productInfos = {...this.state.productInfos, rows: productInfo.Purchase_Order_History}
          this.props.setValue('purchaseOrderForm', 'RefSalePrice', nextProps.productInfo.ProductNum.PriceLv5);
          this.setState({productInfo: productInfo, productInfos: productInfos});
        }
        if(nextProps.miscCostValue && nextProps.miscCostValue != this.props.miscCostValue) {
          this.setState({miscCostValue: nextProps.miscCostValue})
        }
        if(nextProps.handlingCostValue && nextProps.handlingCostValue != this.props.handlingCostValue) {
          this.setState({handlingCostValue: nextProps.handlingCostValue})
        }
        if(nextProps.shippingCostValue && nextProps.shippingCostValue != this.props.shippingCostValue) {
          this.setState({shippingCostValue: nextProps.shippingCostValue})
        }
        if (nextProps.dirty != this.props.dirty) {
            this.setState({
                dirty: nextProps.dirty
            });
        }

        // Once user select a vendor, load its address and contacts.
        if (nextProps.vendorsValue && nextProps.vendorsValue != this.props.vendorsValue) {
          if (this.refs.Products && !this.state.firstRender) {
              this.refs.Products.getRenderedComponent().props.fields.removeAll();
          }
          if (nextProps.vendorsValue.value) {
              this.props.fetchVendorDetail(nextProps.vendorsValue.value);
              this.props.fetchProductsByVendor(nextProps.vendorsValue.value);
          }
          if (this.state.firstRender) this.state.firstRender = false
      }

        // Also, if vendor has been chosen in the template user'll work on, load related products.
        if (nextProps.currentPurchaseOrderDetail != this.props.currentPurchaseOrderDetail && nextProps.currentPurchaseOrderDetail) {
          const  currentPurchaseOrderDetail = nextProps.currentPurchaseOrderDetail;
          if(currentPurchaseOrderDetail.Purchase_Order_Line != null){
            let newRows = [];
            let totalPriceForTax = 0;
            let totalPriceForAllLines = 0;
            currentPurchaseOrderDetail.Purchase_Order_Line.map(
              (line) => {
                let newProduct = {};
                newProduct["Product_id"] = line.Product_id.Product_id;
                newProduct["Name"] = line.Product_id.Name;
                newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
                newProduct["Quantity"] = line.Quantity;
                newProduct["CRV"] = line.Product_id.CRV;
                newProduct["ProductNum"] = line.Product_id.ProductNum;
                newProduct["Description"] = line.Product_id.Description;
                newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
                newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
                newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
                newProduct["NetWeight"] = line.Product_id.NetWeight;
                newProduct["TotalNetWeight"] = roundTo(parseFloat((line.Product_id.NetWeight)*(line.Quantity)), 2).toFixed(2);
                newProduct["TotalShippingWeight"] = roundTo(parseFloat((line.Product_id.ShippingWeight)*(line.Quantity)), 2).toFixed(2);
                newProduct["RefNum"] = line.Product_id.RefNum;
                newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice)*10000)/10000).toFixed(2);
                newProduct["IsTaxable"] = line.Product_id.IsTaxable;
                newProduct["Remark"] = line.Remark;
                newProduct["ProductType"] = line.Product_id.ProductType;
                newProduct["PackageSize"] = line.Product_id.PackageSize;
                newProduct["PackageType"] = line.Product_id.PackageType;

                newRows = [...newRows, newProduct];
                if(line.Product_id.IsTaxable) {
                  totalPriceForTax += line.TotalPrice;
                }
                totalPriceForAllLines += line.TotalPrice;
              }
            )
            let newTotalShippingWeight = currentPurchaseOrderDetail.FinalShippingWeight;
            let newTotalNetWeight = currentPurchaseOrderDetail.FinalNetWeight;
            // let newTotalPrice = parseFloat(currentPurchaseOrderDetail.TotalPrice).toFixed(2);
            // let finalPrice = parseFloat(currentPurchaseOrderDetail.FinalPrice).toFixed(2);

            let taxRate = currentPurchaseOrderDetail.TaxRate || 0;
            let discountValue = currentPurchaseOrderDetail.Discount || 0;
            let miscCostValue = currentPurchaseOrderDetail.MiscCost || 0;
            let handlingCostValue = currentPurchaseOrderDetail.HandlingCost || 0;
            let shippingCostValue = currentPurchaseOrderDetail.ShippingCost || 0;
            let adjustmentValue = currentPurchaseOrderDetail.PriceAdjustment || 0;
            let CRV = currentPurchaseOrderDetail.CRV;
            let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
            taxValue = Math.round(0.0001 + taxValue * 100) / 100;

            let totalPrice = 0;
            totalPriceForTax = 0;
            totalPriceForAllLines = 0;
            let NewCRV = 0;
            let totalShippingWeight = 0;
            let totalNetWeight = 0;
            newRows.map(row => {
              totalPrice += parseFloat(row["TotalPrice"]);
              totalPriceForAllLines += parseFloat(row["TotalPrice"]);
              if(row["IsTaxable"]) {
                totalPriceForTax += parseFloat(row["TotalPrice"]);
              }
              NewCRV += ((Math.round(parseFloat(row["CRV"])* 100) / 100) || 0)*(parseFloat(row["Quantity"])||0);
              totalShippingWeight += (parseFloat(row["Quantity"]) || 0)*(parseFloat(row["ShippingWeight"]) || 0);
              totalNetWeight += (parseFloat(row["Quantity"]) || 0)*(parseFloat(row["NetWeight"]) || 0);
            })
            totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
            totalPriceForTax = parseFloat(totalPriceForTax);
            totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);

            let finalPrice = (NewCRV + (Math.round(miscCostValue * 100) / 100) + (Math.round(adjustmentValue * 100) / 100) + (Math.round(handlingCostValue * 100) / 100) + (Math.round(shippingCostValue * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + (Math.round((totalPriceForTax * taxRate / 100.0) * 100) / 100));
            finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);

            this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
            this.setState({ rows: newRows,
              totalShippingWeight: currentPurchaseOrderDetail.FinalShippingWeight,
              totalNetWeight: newTotalNetWeight,
              totalPrice: totalPrice,
              totalPriceForTax: totalPriceForTax,
              totalPriceForAllLines: totalPriceForAllLines,
              finalPrice: finalPrice,
              taxRate: taxRate,
              discountValue: discountValue,
              miscCostValue,
              handlingCostValue,
              shippingCostValue,
              adjustmentValue,
              CRV
            });
          }
          let updateTime = new Date(currentPurchaseOrderDetail.UpdateTime);
          updateTime = convertLocalDate(updateTime, 'MM-DD-YY');
          this.setState({
            modified_by: currentPurchaseOrderDetail.Modifier_User_Name,
            updateTime: updateTime,
            created_by: currentPurchaseOrderDetail.Purchaser_User_Name,
            firstRender: true
          });
            this.props.initializeForm(currentPurchaseOrderDetail, [],"purchaseOrderForm");
            this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        }

        if (!nextProps.vendorsValue) {
            this.props.resetCurrentVendor();
        }

        if(nextProps.priceTypeValue != this.props.priceTypeValue ) {
            this.setState({ priceType: nextProps.priceTypeValue });
        }

        // Calculate the sum of the price and weight for products.

        if (nextProps.products[0] && nextProps.productsValue) {

            let { products } = nextProps;

            let calculatedProducts = nextProps.productsValue;

            function round(value, decimals) {
                return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
            }

            this.setState({
                calculatedProducts: calculatedProducts,
            })
        }

        if (nextProps.warehouses && nextProps.warehouses != this.props.warehouses) {
          if(nextProps.warehouses[0])
            this.props.setDefaults('purchaseOrderForm', nextProps.warehouses[0].Warehouse_id);
        }

        if (nextProps.currentPurchaseQuoteDetail != this.props.currentPurchaseQuoteDetail && nextProps.currentPurchaseQuoteDetail) {
          const  currentPurchaseQuoteDetail = nextProps.currentPurchaseQuoteDetail;
          if(currentPurchaseQuoteDetail.Purchase_Order_Line != null){
            let newRows = [];
            let totalPriceForTax = 0;
            let totalPriceForAllLines = 0;
            currentPurchaseQuoteDetail.Purchase_Order_Line.map(
              (line) => {
                let newProduct = {};
                newProduct["Product_id"] = line.Product_id.Product_id;
                newProduct["Name"] = line.Product_id.Name;
                newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
                newProduct["Quantity"] = line.Quantity;

                newProduct["ProductNum"] = line.Product_id.ProductNum;
                newProduct["Description"] = line.Product_id.Description;
                newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
                newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
                newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
                newProduct["NetWeight"] = line.Product_id.NetWeight;
                newProduct["TotalNetWeight"] = roundTo(parseFloat((line.Product_id.NetWeight)*(line.Quantity)), 2).toFixed(2);
                newProduct["TotalShippingWeight"] = roundTo(parseFloat((line.Product_id.ShippingWeight)*(line.Quantity)), 2).toFixed(2);
                newProduct["RefNum"] = line.Product_id.RefNum;
                newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice)*10000)/10000).toFixed(2);
                newProduct["IsTaxable"] = line.Product_id.IsTaxable;
                newProduct["Remark"] = line.Remark;
                newProduct["ProductType"] = line.Product_id.ProductType;
                newProduct["PackageSize"] = line.Product_id.PackageSize;
                newProduct["PackageType"] = line.Product_id.PackageType;

                newRows = [...newRows, newProduct];
                if(line.Product_id.IsTaxable) {
                  totalPriceForTax += line.TotalPrice;
                }
                totalPriceForAllLines += line.TotalPrice;
              }
            )
            let newTotalShippingWeight = currentPurchaseQuoteDetail.FinalShippingWeight;
            let newTotalNetWeight = currentPurchaseQuoteDetail.FinalNetWeight;
            let newTotalPrice = parseFloat(currentPurchaseQuoteDetail.TotalPrice).toFixed(2);
            let finalPrice = parseFloat(currentPurchaseQuoteDetail.FinalPrice).toFixed(2);
            let taxRate = currentPurchaseQuoteDetail.TaxRate || 0;
            let discountValue = currentPurchaseQuoteDetail.Discount || 0;
            let miscCostValue = currentPurchaseQuoteDetail.MiscCost || 0;
            let handlingCostValue = currentPurchaseQuoteDetail.HandlingCost || 0;
            let shippingCostValue = currentPurchaseQuoteDetail.ShippingCost || 0;
            let adjustmentValue = currentPurchaseQuoteDetail.PriceAdjustment || 0;
            let CRV = currentPurchaseQuoteDetail.CRV;
            let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
            taxValue = Math.round(0.0001 + taxValue * 100) / 100;
            this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
            this.setState({ rows: newRows,
              totalShippingWeight: currentPurchaseQuoteDetail.FinalShippingWeight,
              totalNetWeight: newTotalNetWeight,
              totalPrice: newTotalPrice,
              totalPriceForTax: totalPriceForTax,
              totalPriceForAllLines: totalPriceForAllLines,
              finalPrice: finalPrice,
              taxRate: taxRate,
              discountValue: discountValue,
              miscCostValue,
              handlingCostValue,
              shippingCostValue,
              adjustmentValue,
              CRV
            });
          }
          let updateTime = new Date(currentPurchaseQuoteDetail.UpdateTime);
          updateTime = convertLocalDate(updateTime, 'MM-DD-YY');
          this.setState({
            modified_by: currentPurchaseQuoteDetail.Modifier_User_Name,
            updateTime: updateTime,
            created_by: currentPurchaseQuoteDetail.Purchaser_User_Name,
            firstRender: true
          });
            this.props.initializeForm(currentPurchaseQuoteDetail, [],"purchaseOrderForm");
            this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        }

        if (nextProps.currentPurchaseTemplateDetail != this.props.currentPurchaseTemplateDetail && nextProps.currentPurchaseTemplateDetail) {
          const  currentPurchaseTemplateDetail = nextProps.currentPurchaseTemplateDetail;
          if(currentPurchaseTemplateDetail.Purchase_Template_Line != null){
            let newRows = [];
            let totalPriceForTax = 0;
            let totalPriceForAllLines = 0;
            currentPurchaseTemplateDetail.Purchase_Template_Line.map(
              (line) => {
                let newProduct = {};
                newProduct["Product_id"] = line.Product_id.Product_id;
                newProduct["Name"] = line.Product_id.Name;
                newProduct["EstSalePrice"] = line.EstSalePrice; //products[index].LowestSalePrice;
                newProduct["Quantity"] = line.Quantity;

                newProduct["ProductNum"] = line.Product_id.ProductNum;
                newProduct["Description"] = line.Product_id.Description;
                newProduct["MeasureUnit"] = line.Product_id.MeasureUnit;
                newProduct["FOBUnitPrice"] = line.FOBUnitPrice; //products[index].RefPrice;
                newProduct["ShippingWeight"] = line.Product_id.ShippingWeight;
                newProduct["NetWeight"] = line.Product_id.NetWeight;
                newProduct["TotalNetWeight"] = (line.Product_id.NetWeight)*(line.Quantity);
                newProduct["TotalShippingWeight"] = (line.Product_id.ShippingWeight)*(line.Quantity);
                newProduct["RefNum"] = line.Product_id.RefNum;
                newProduct["TotalPrice"] = (Math.round(parseFloat(line.TotalPrice)*10000)/10000).toFixed(2);
                newProduct["IsTaxable"] = line.Product_id.IsTaxable;
                newProduct["Remark"] = line.Remark;
                newProduct["ProductType"] = line.Product_id.ProductType;
                newProduct["PackageSize"] = line.Product_id.PackageSize;
                newProduct["PackageType"] = line.Product_id.PackageType;

                newRows = [...newRows, newProduct];
                if(line.Product_id.IsTaxable) {
                  totalPriceForTax += line.TotalPrice;
                }
                totalPriceForAllLines += line.TotalPrice;
              }
            )
            let newTotalShippingWeight = currentPurchaseTemplateDetail.FinalShippingWeight;
            let newTotalNetWeight = currentPurchaseTemplateDetail.FinalNetWeight;
            let newTotalPrice = parseFloat(currentPurchaseTemplateDetail.TotalPrice).toFixed(2);
            let finalPrice = parseFloat(currentPurchaseTemplateDetail.FinalPrice).toFixed(2);
            let taxRate = currentPurchaseTemplateDetail.TaxRate || 0;
            let discountValue = currentPurchaseTemplateDetail.Discount || 0;
            let miscCostValue = currentPurchaseTemplateDetail.MiscCost || 0;
            let handlingCostValue = currentPurchaseTemplateDetail.HandlingCost || 0;
            let shippingCostValue = currentPurchaseTemplateDetail.ShippingCost || 0;
            let adjustmentValue = currentPurchaseTemplateDetail.PriceAdjustment || 0;
            let CRV = currentPurchaseTemplateDetail.CRV;
            let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
            taxValue = Math.round(0.0001 + taxValue * 100) / 100;
            this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
            this.setState({ rows: newRows,
              totalShippingWeight: currentPurchaseTemplateDetail.FinalShippingWeight,
              totalNetWeight: newTotalNetWeight,
              totalPrice: newTotalPrice,
              totalPriceForTax: totalPriceForTax,
              totalPriceForAllLines: totalPriceForAllLines,
              finalPrice: finalPrice,
              taxRate: taxRate,
              discountValue: discountValue,
              miscCostValue,
              handlingCostValue,
              shippingCostValue,
              adjustmentValue,
              CRV
            });
          }
          let updateTime = new Date(currentPurchaseTemplateDetail.UpdateTime);
          updateTime = convertLocalDate(updateTime, 'MM-DD-YY');
          this.setState({
            modified_by: currentPurchaseTemplateDetail.Modifier_User_Name,
            updateTime: updateTime,
            created_by: currentPurchaseTemplateDetail.Purchaser_User_Name,
            firstRender: true
          });
            this.props.initializeForm(currentPurchaseTemplateDetail, [],"purchaseOrderForm");
            this.props.setDefaultSearchType('RefNum', 'purchaseOrderForm');
        }

        if (nextProps.purchaseOrderProduct && nextProps.purchaseOrderProduct !== this.props.purchaseOrderProduct) {
          this.selectInventoryInfo(nextProps.purchaseOrderProduct);
          this.props.fetchProductInfo(nextProps.purchaseOrderProduct.Product_id);
          this.props.setPriceValues(nextProps.purchaseOrderProduct.ProductCost, nextProps.purchaseOrderProduct.LowestSalePrice, 'purchaseOrderForm');
          this.props.setDefaultOfForm('Weight', nextProps.purchaseOrderProduct.NetWeight, 'purchaseOrderForm');
          this.props.setValue('purchaseOrderForm', 'RefSalePrice', nextProps.purchaseOrderProduct.PriceLv5);
        }

        if(nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
          this.setState({ PdfFrameLoaded: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
        return false;
      }

      return true;
    }

    handleResize(e) {
        if(window.innerHeight < 930) {
          this.setState({yourOrderTableHeight: (this.state.yourOrderKey == 1)? 198 : 350});
        }
        else {
          this.setState({yourOrderTableHeight: (this.state.yourOrderKey == 1)? 198 : 350});
        }
    }

    // If the form is dirty, ask for confirmation.

    routerWillLeave(nextLocation) {
      if (this.props.pristine == false){
        alert("you will leave this page");
      }
    }

    handleOnFocus(event) {
      event.target.select();
    }

    handleSelect(yourOrderKey) {
      switch (yourOrderKey) {
        case 1:
          this.setState({yourOrderTableHeight: (window.innerHeight < 930) ? 198 : 198, yourOrderKey: yourOrderKey})
          break;
        default:
          this.setState({yourOrderTableHeight: (window.innerHeight < 930) ? 350 : 350, yourOrderKey: yourOrderKey})
      }
    }

    openShowCustomer() {
      this.setState({showCustomerOpen: true});
    }

    closeShowCustomer() {
      this.setState({showCustomerOpen: false});
    }

    openShowInventory(event) {
      if(!(this.props.allProducts) || (this.props.allProducts=="")){
        return;
      }
      switch (event.charCode) {
          case 13: // ENTER
              event.preventDefault();
              this.setState({showInventoryOpen: true});
              break;
      }
    }


    closeShowInventory(value) {
      this.setState({showInventoryOpen: false});
      if(value)
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }

    openShowPOCreated(){
      this.setState({showPOCreatedOpen: true});
    }

    closeShowPOCreated(){
      this.setState({showPOCreatedOpen: false})
    }

    openConfirm() { this.setState({ confirmOpen: true }); }

    closeConfirm() {
      this.setState({ confirmOpen: false });
    }

    openChangeTax() {
      this.setState({ changeTaxOpen: true });
    }
    closeChangeTax() {
      this.setState({ changeTaxOpen: false });
      const { CRV, totalPriceForAllLines, discountValue, totalPriceForTax, taxRate } = this.state;
      const miscCostValue = parseFloat(this.state.miscCostValue) || 0;
      const handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
      const shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
      const adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
      let finalPrice = (CRV + (Math.round(miscCostValue * 100) / 100) + (Math.round(adjustmentValue * 100) / 100) + (Math.round(handlingCostValue * 100) / 100) + (Math.round(shippingCostValue * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + (Math.round((totalPriceForTax * taxRate / 100.0) * 100) / 100));
      finalPrice = parseFloat(Math.round(finalPrice * 100) / 100).toFixed(2);
      this.setState({
        finalPrice,
      })
    }


    redirect() {
      if (this.props.purchaseQuoteCreated ||this.props.purchaseQuoteEdited ) {
        this.context.router.push('/purchaseQuote');
      }
      else if (this.props.purchaseTemplateCreated || this.props.purchaseTemplateEdited) {
        this.context.router.push('/purchaseTemplate');
      }
      else {
        this.context.router.push('/purchaseOrder');
      }
    }

    setAllProductQuantity = (quantity) => {
      this.props.setDefaultOfForm('AllProd_Quantity', quantity, 'purchaseOrderForm');
    }

    updateTimeformatDate(date) {
      let formattedDate = date.getFullYear() + '-';
      let month = date.getMonth()+1
      if( month < 10)
        formattedDate += '0' + month + '-';
      else
        formattedDate += month + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    selectInventoryInfo(selectedInventoryRow) {
      this.setState({ selectedInventoryRow });
      const index = _.findIndex(this.props.simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
      if (index > -1) {
        this.props.fetchProductInfo(this.props.simplifiedProducts[index].Product_id);
        this.props.setPriceValues(this.props.simplifiedProducts[index].ProductCost, this.props.simplifiedProducts[index].LowestSalePrice, 'purchaseOrderForm');
        if((this.props.simplifiedProducts[index].ProductType == "Non-Fixed" || this.props.simplifiedProducts[index].ProductType == "Per-Pound") && (!this.props.simplifiedProducts[index].NetWeight) ) {
          alert("Net Weight Cannot Be 0! Change Net Weight in Product Page!");
        }
        this.props.setDefaultOfForm('Weight', this.props.simplifiedProducts[index].NetWeight, 'purchaseOrderForm');
      }
    }

    clearInventoryInfo = () => {
      this.setState({
        selectedInventoryRow: {},
        productInfo: {},
      });
    }

    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate() + 'T';
      } else {
        formattedDate += date.getDate() + 'T';
      }

      if (date.getHours() < 10) {
        formattedDate += '0' + date.getHours() + ':';
      } else {
        formattedDate += date.getHours() + ':';
      }

      if (date.getMinutes() < 10) {
        formattedDate += '0' + date.getMinutes() + ':';
      } else {
        formattedDate += date.getMinutes() + ':';
      }

      if (date.getSeconds < 10) {
        formattedDate += '0' + date.getSeconds();
      } else {
        formattedDate += date.getSeconds();
      }
      return formattedDate;
    }

    // Selection -> Selection
    handleKeyPressTargetSelection(value, event) {
      if(event.keyCode == 13){
        if(value == "") {
          event.preventDefault();
          return;
        }
        this.refs[value].getRenderedComponent().refs.select.focus();
        // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    // Selection -> Input
    handleKeyPressTargetInput(value, event) {
      if(event.keyCode == 13){
        ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      }
    }

    // Input -> Input
    handleKeyPress = (value, event) => {
      if (event.charCode === 13) {
        event.preventDefault();
        if (typeof value === 'object') {
          if (this.state.selectedInventoryRow && this.state.selectedInventoryRow.ProductType == 'Non-Fixed')
            ReactDOM.findDOMNode(this.refs[value[1]].getRenderedComponent().myInput.refs.input).focus();
          else
            ReactDOM.findDOMNode(this.refs[value[0]].getRenderedComponent().myInput.refs.input).focus();
        } else {
          if (value === 'miscNote' && isNaN(event.target.value)) {
            this.props.validate(event.target.value);
            return;
          }
          if ((!isNumber(event.target.value) || event.target.value < 0) && value !== 'allProd_Quantity' && value !== 'miscNote') {
            this.props.validate(event.target.value);
            return;
          }
          ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
        }
      }
    }

    handleKeyPressMove(event) {
      if(event.charCode == 13){
        event.preventDefault();
        this.moveToProductsListFromAll();
      }
    }

    handleKeyPressMoveVendor(event) {
      if(event.charCode == 13){
        event.preventDefault();
        this.moveToProductsList();
      }
    }

    handleFocusQty = () => {
      ReactDOM.findDOMNode(this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).focus();
      ReactDOM.findDOMNode(this.refs['allProd_Quantity'].getRenderedComponent().myInput.refs.input).select();
    }

    // Render Select options dynamically with the information on the server.

    renderVendorsDetail() {
        let vendorNameOptions =[]; // Return a JSON in the format of React-Select's options
        let vendorNumOptions = [];
        let vendorTelOptions = [];
        if (this.props.vendorIsLoading && !this.props.vendorError){
            vendorNameOptions = [{value: "Loading", label: "Loading"}]; // Return a JSON in the format of React-Select's options
            vendorNumOptions = [{value: "Loading", label: "Loading"}];
            vendorTelOptions = [{value: "Loading", label: "Loading"}];
        } // If vendor is loading, show a spinner.
        let SelectionForVendor = (this.props.currentPurchaseOrder
          || this.props.currentPurchaseQuote
          || this.props.currentPurchaseTemplate) ? DisabledSelection : Selection;
        if (this.props.vendorError) return <div><Translate value="error" /></div> // If vendor is loading, show a spinner.
        else {
            vendorNameOptions = this.getVendorNameOptions(); // Return a JSON in the format of React-Select's options
            vendorNumOptions = this.getVendorNumOptions();
            vendorTelOptions = this.getVendorTelOptions();
          return (
                  <Col xs={4} id="vendor-info">
                    <h4><Translate value="vendor_information" /></h4>
                    <div className="form-group">
                      <label className="col-xs-3">
                        <Translate value="name" /><span className="asteriksReq">*</span>
                      </label>
                      <div className="col-xs-8">
                        <Field
                          name="Vendor_id"
                          ref="vendor_name"
                          withRef
                          component={SelectionForVendor}
                          options={vendorNameOptions}
                          onKeyPress={(event) => {
                            if (event.keyCode == 13) {
                              const myField = document.getElementById('purchase-auto-suggest');
                              if (myField) {
                                myField.select();
                              }
                            }
                          }}
                          matchPos="any"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-xs-3">
                        <Translate value="vendor_no" />
                      </label>
                      <div className="col-xs-8">
                        <Field
                          name="Vendor_id"
                          ref="vendor_no"
                          withRef
                          component={SelectionForVendor}
                          options={vendorNumOptions}
                          onKeyPress={(event) => {
                            if (event.keyCode == 13) {
                              const myField = document.getElementById('purchase-auto-suggest');
                              if (myField) {
                                myField.select();
                              }
                            }
                          }}
                          matchPos="any"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="col-xs-3">
                        <Translate value="phone" />
                      </label>
                      <div className="col-xs-8">
                        <Field
                          name="Vendor_id"
                          ref="vendor_no"
                          withRef
                          component={SelectionForVendor}
                          options={vendorTelOptions}
                          onKeyPress={(event) => {
                            if (event.keyCode == 13) {
                              const myField = document.getElementById('purchase-auto-suggest');
                              if (myField) {
                                myField.select();
                              }
                            }
                          }}
                          matchPos="any"
                        />
                      </div>
                    </div>
                  </Col>
          )
        }
      }


    // Push vendor name and number in to 2 JSON arrays.

    getVendorNameOptions() {
        var vendorNameOptions = [];
        this.props.vendors.map(vendor => {
            vendorNameOptions.push({ value: vendor.Vendor_id, label: vendor.Name })
        });
        return vendorNameOptions;
    }

    getVendorNumOptions() {
        let vendorNumOptions = [];
        this.props.vendors.map(vendor => {
            vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum })
        });
        return vendorNumOptions;
    }

    getVendorTelOptions() {
      let vendorNumOptions = [];
      this.props.vendors.map(vendor => {
          vendorNumOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone })
      });
      return vendorNumOptions;
    }

    getTaxRateOptions() {
      let taxRateOptions = [];
      if(this.props.taxRates) {
        this.props.taxRates.map(taxRate => {
            taxRateOptions.push({ value: taxRate.Rate, label: taxRate.Rate })
        });
      }
      return taxRateOptions;
    }

    renderBillingAddress1() {
        const { vendorsValue, currentVendorDetail } = this.props;
        if(currentVendorDetail && currentVendorDetail.Billing) {
            const Address1 = currentVendorDetail.Billing.Street;
            return Address1;
        }
    }

    renderBillingAddress2() {
        const { vendorsValue, currentVendorDetail } = this.props;
        if(currentVendorDetail && currentVendorDetail.Billing) {
            const Address2 = currentVendorDetail.Billing.City + " " + currentVendorDetail.Billing.State + currentVendorDetail.Billing.Zip;
            return Address2;
        }
    }

    // Once a vendor is chosen, render its shipping address and contacts

    renderVendorAddress() {
      const {currentVendorDetail} = this.props;
      if (this.props.currentVendorDetail) {
            let vendorAddressOptions = this.getVendorAddressOptions();
            let vendorContactOptions = this.getVendorContactOptions();
            if(!this.props.shippingMethod)
              return;
            else if(this.props.shippingMethod == "Pickup" || this.props.shippingMethod.value == "Pickup"){
               return (
                 <div>
                   <Col xs={ 12 }>
                    <label><Translate value="pickup_vendor_address" /></label>
                    <Field name="Pickup_VendorDetail_id" component={Selection} ref="pickup_VendorDetail_id" withRef={true}
                          options={vendorAddressOptions} defaultValue={vendorAddressOptions[0]}/>
                    </Col>
                    <Col xs={ 12 }>
                      <label><Translate value="pickup_contact" /></label>
                      <Field name="Pickup_VendorDetail_id" component={Selection} ref="pickup_VendorDetail_id" withRef={true}
                        options={vendorContactOptions} defaultValue={vendorContactOptions[0]}/>
                   </Col>
                 </div>
              )
            }
            else return
      }
    }

    getVendorAddressOptions() {
        var vendorAddressOptions = [];
        if(this.props.currentVendorDetail && this.props.currentVendorDetail.Shipping) {
          this.props.currentVendorDetail.Shipping.map(address => {
              vendorAddressOptions.push({ value: address.VendorDetail_id, label: address.AddressName+', '+address.City })
          });
        }
        return vendorAddressOptions;
    }

    getVendorContactOptions() {
        var vendorContactOptions = [];
        if(this.props.currentVendorDetail && this.props.currentVendorDetail.Shipping) {
          this.props.currentVendorDetail.Shipping.map(contact => {
              vendorContactOptions.push({ value: contact.VendorDetail_id, label: contact.FirstName+' '+contact.LastName })
          });
        }
        return vendorContactOptions;
    }

    renderVendorContactInformation() {
        const { currentVendorDetail, vendorsValue, vendorContactValue } = this.props;
        if(vendorContactValue && currentVendorDetail ) {
            const index = _.findIndex(currentVendorDetail.Shipping, { 'VendorDetail_id': vendorContactValue });
            if (index != -1) return (
                <div>
                    <Row>
                        <Col xs={ 3 }>
                          <label><Translate value="name" />:</label>
                        </Col>
                        <Col xs={ 9 }>
                            {currentVendorDetail.Shipping[index].FirstName+' '+currentVendorDetail.Shipping[index].LastName}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={ 3 }>
                          <label><Translate value="email" />:</label>
                        </Col>
                        <Col xs={ 9 }>
                            {currentVendorDetail.Shipping[index].Email}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={ 3 }>
                          <label><Translate value="phone" />:</label>
                        </Col>
                        <Col xs={ 9 }>
                            {currentVendorDetail.Shipping[index].Telephone}
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    checkisValid() {
      if (!isNumber(this.props.allProdQuantity) || this.props.allProdQuantity < 0 || !isNumber(this.props.allProdFOBUnitPrice) || this.props.allProdFOBUnitPrice < 0){
        return false
      }
      return true
    }

    moveToProductsListFromAll() {
      if (this.state.selectedInventoryRow.Product_id == null) {
        this.setState({ confirmOpen: true, case: 'chooseProduct' });
        return;
      }
      const { simplifiedProducts, productInformation, allProdRemark } = this.props;
      const quantity = this.props.allProdQuantity || 0;
      let newProduct = {};
      let rows = this.state.rows;
      var selectedInventoryRow = this.state.selectedInventoryRow;
      const checkDuplicate = _.findIndex(rows, {'Product_id': selectedInventoryRow.Product_id});
      if(checkDuplicate > -1){
        alert("Product already exists!");
        this.props.resetAllProducts('purchaseOrderForm');
        this.setState({ suggestValue: '' });
        return;
      }
      if(!this.checkisValid()){
        return;
      }
      // const index = _.findIndex(simplifiedProducts, { 'Product_id': selectedInventoryRow.Product_id });
      // if (index > -1) {
        // INCOMPLETE: change this to refPrice and fix other places where refPrice
        let refPrice = this.props.allProdFOBUnitPrice || 0;

        newProduct["Product_id"] = this.state.selectedInventoryRow.Product_id;
        newProduct["IsTaxable"] = this.state.selectedInventoryRow.IsTaxable;
        newProduct["ProductNum"] = this.state.selectedInventoryRow.ProductNum;
        newProduct["Name"] = this.state.selectedInventoryRow.Name;
        newProduct["Description"] = this.state.selectedInventoryRow.Description;
        newProduct["MeasureUnit"] = this.state.selectedInventoryRow.MeasureUnit;
        newProduct["ProductType"] = this.state.selectedInventoryRow.ProductType;
        newProduct["PackageSize"] = this.state.selectedInventoryRow.PackageSize;
        newProduct["FOBUnitPrice"] = refPrice; //products[index].RefPrice;
        newProduct["ShippingWeight"] = this.state.selectedInventoryRow.ShippingWeight;
        newProduct["NetWeight"] = this.state.selectedInventoryRow.NetWeight;
        newProduct["TotalShippingWeight"] = (this.state.selectedInventoryRow.ShippingWeight)*(quantity);
        newProduct["TotalNetWeight"] = (this.state.selectedInventoryRow.NetWeight)*(quantity);
        newProduct["RefNum"] = this.state.selectedInventoryRow.RefNum;
        newProduct["Quantity"] = quantity;
        newProduct["NetWeight"] = this.state.selectedInventoryRow.NetWeight;
        newProduct["CRV"] = this.state.selectedInventoryRow.CRV;
        const weight = parseFloat(newProduct["NetWeight"]) || 0;
        if(this.state.selectedInventoryRow.ProductType == "Per-Pound") {
          newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity*refPrice*weight)* 100) / 100).toFixed(2);
        }
        else if(this.state.selectedInventoryRow.ProductType == "Non-Fixed") {
          newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity*refPrice*weight)* 100) / 100).toFixed(2);
        }
        else {
          newProduct["TotalPrice"] = parseFloat(Math.round(parseFloat(quantity*refPrice)* 100) / 100).toFixed(2);
        }

        newProduct["Remark"] = allProdRemark;
        let newRows = [...this.state.rows];
        newRows.unshift(newProduct);
        let totalShippingWeight = 0;
        let totalNetWeight = 0;
          totalNetWeight = parseFloat(this.state.totalNetWeight) + (parseFloat(quantity) || 0)*(parseFloat(newProduct["NetWeight"]) || 0);
          totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
          totalShippingWeight = parseFloat(this.state.totalShippingWeight) + (parseFloat(quantity) || 0)*(parseFloat(newProduct["ShippingWeight"]) || 0);
          totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
        let totalPrice = parseFloat(this.state.totalPrice) + parseFloat(newProduct["TotalPrice"]);
        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);

        let totalPriceForTax = parseFloat(this.state.totalPriceForTax);
        let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines);

        if(this.state.selectedInventoryRow.IsTaxable) {
          totalPriceForTax = totalPriceForTax + parseFloat(newProduct["TotalPrice"]);
        }
        totalPriceForAllLines = totalPriceForAllLines + parseFloat(newProduct["TotalPrice"]);
        totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);

        let discountValue = parseFloat(this.state.discountValue) || 0;
        let taxRate = parseFloat(this.state.taxRate) || 0;
        let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
        let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
        let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
        let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;

        let CRV = +roundTo(this.state.CRV + newProduct["CRV"]*(parseFloat(quantity) || 0), 2).toFixed(2);

        let finalPrice = ((Math.round(CRV * 100) / 100) + (Math.round(miscCostValue * 100) / 100) + (Math.round(adjustmentValue * 100) / 100) + (Math.round(handlingCostValue * 100) / 100) + (Math.round(shippingCostValue * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + (Math.round((totalPriceForTax * taxRate / 100.0) * 100) / 100));
        finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
        let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
        taxValue = Math.round(0.0001 + taxValue * 100) / 100;
        this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
        this.setState({
          rows: newRows,
          totalShippingWeight: totalShippingWeight || 0,
          totalNetWeight: totalNetWeight || 0,
          totalPrice: totalPrice || 0,
          totalPriceForTax: totalPriceForTax || 0,
          totalPriceForAllLines: totalPriceForAllLines || 0,
          CRV,
          finalPrice: finalPrice || 0,
          quantity: 0,
          productType: null,
          suggestValue: '',
        });
      // }
      // ReactDOM.findDOMNode(this.refs["allProducts"].getRenderedComponent().myInput.refs.input).focus();
      this.props.resetAllProducts('purchaseOrderForm');
    }

    moveToProductsList(){
      const { products, productInformation, remark } = this.props;
      const quantity = 0;
      let rows = this.state.rows;
      let vendorProducts = [...this.state.vendorProducts.selectedIndexes];
      let newRows = [...this.state.rows];
      let checkDuplicate = -1;
      let index = -1;
      vendorProducts.map( productInformation => {
        checkDuplicate = _.findIndex(rows, {'Product_id': this.state.vendorProducts.rows[productInformation].Product_id});
        if(checkDuplicate > -1){
          alert("Product already exists!");
        }
        else {
          let newProduct = {};
          index = _.findIndex(products, { 'Product_id': this.state.vendorProducts.rows[productInformation].Product_id });
          newProduct = {...products[index]};
          newProduct["FOBUnitPrice"] = products[index].ProductCost; //products[index].RefPrice;
          newProduct["TotalShippingWeight"] = (products[index].ShippingWeight)*(quantity);
          newProduct["TotalNetWeight"] = (products[index].NetWeight)*(quantity);
          newProduct["Quantity"] = 0;
          newProduct["TotalPrice"] = parseFloat("0").toFixed(2);
          newRows.unshift(newProduct);
        }
      })
      this.setState({
        rows: newRows,
        quantity: 0
      });
      this.props.resetAllProducts('purchaseOrderForm');
      // this.refs["productInformation"].getRenderedComponent().refs.select.focus();
    }

    moveOffFromProductsList(Product_id){
        let newRows = this.state.rows;
        let totalShippingWeight = 0;
        let totalNetWeight = 0;
        let totalPrice = 0;
        let discountValue = parseFloat(this.state.discountValue) || 0;
        let taxRate = parseFloat(this.state.taxRate) || 0;
        newRows = newRows.filter(function(obj){
              return obj.Product_id != Product_id;
        })
        let totalPriceForTax = 0;
        let totalPriceForAllLines = 0;
        let CRV = 0;
        newRows.map(
          newRow => {
            CRV = (Math.round(CRV + ((parseFloat(newRow["CRV"]) || 0)*(parseFloat(newRow["Quantity"]) || 0))* 100) / 100);
            totalShippingWeight = parseFloat(totalShippingWeight) + parseFloat(newRow["Quantity"])*parseFloat(newRow["ShippingWeight"]);
            totalNetWeight = parseFloat(totalNetWeight) + parseFloat(newRow["Quantity"])*parseFloat(newRow["NetWeight"]);
            totalPrice = (parseFloat(totalPrice)||0) + (parseFloat(newRow["TotalPrice"])||0);
            if(newRow["IsTaxable"]) {
              totalPriceForTax = (parseFloat(totalPriceForTax)||0) + (parseFloat(newRow["TotalPrice"])||0);
            }
            totalPriceForAllLines = (parseFloat(totalPriceForAllLines)||0) + (parseFloat(newRow["TotalPrice"])||0);
          }
        )
        totalShippingWeight = (parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2)) || 0;
        totalNetWeight = (parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2)) || 0;
        totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
        let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
        let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
        let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
        let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
        let finalPrice = (CRV + (Math.round(miscCostValue * 100) / 100) + (Math.round(adjustmentValue * 100) / 100) + (Math.round(handlingCostValue * 100) / 100) + (Math.round(shippingCostValue * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + (Math.round((totalPriceForTax * taxRate / 100.0) * 100) / 100));
        finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
        let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
        taxValue = Math.round(0.0001 + taxValue * 100) / 100;
        this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")
        this.setState({rows: newRows,
          selectedRows: null,
          totalShippingWeight: totalShippingWeight,
          totalNetWeight: totalNetWeight,
          totalPrice: totalPrice,
          totalPriceForTax: totalPriceForTax,
          totalPriceForAllLines: totalPriceForAllLines,
          finalPrice: finalPrice,
          CRV});
    }

    handleLowestSalePriceChange(event) {
      this.setState({lowestSalePrice: event.target.value});
    }

    handleQuantityChange(event) {
      this.setState({quantity: event.target.value});
    }

    renderProducts() {
      const moveOffFromProductsList = this.moveOffFromProductsList;
      if (this.props.detailIsLoading && !this.props.detailError) return <Spinner/>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.detailError)}</div></ContentWrapper>
        else {
        let productNumOptions = this.getProductNumOptions();
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return Object.assign({Idx: rowIdx+1}, rows[rowIdx]);
        }

        // Handle the row select function

        const onRowSelect = rows => {
            this.setState(...this.state, { selectedRows: rows });
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             rows.map (r => {
               newRows[r.rowIdx].isSelected = true;
             });
             this.setState({rows: newRows});
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             rows.map (r => {
               newRows[r.rowIdx].isSelected = false;
             });
             this.setState({rows: newRows});
         }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        const onRowClick = (rowIdx, row) => {
            // this.props.fetchSalesOrders();
            if(rowIdx > -1) {
              this.props.fetchProductInfo(row.Product_id);
            }
        }

        // Handle the editable function

        const handleRowUpdated = e => {
          var rows = getRows();
          let discountValue = parseFloat(this.state.discountValue) || 0;
          let taxRate = parseFloat(this.state.taxRate) || 0;
          let weight = parseFloat(rows[e.rowIdx].NetWeight) || 0;
          let price = parseFloat(rows[e.rowIdx].TotalPrice) || 0;
          if(e.updated.Quantity != null && isNumber(e.updated.Quantity) && e.updated.Quantity > 0){
            let quantity = rows[e.rowIdx].Quantity;
            Object.assign(rows[e.rowIdx], e.updated);
            if(rows[e.rowIdx].ProductType == "Per-Pound") {
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.Quantity*rows[e.rowIdx].FOBUnitPrice*weight),2).toFixed(2)});
            }
            else if(rows[e.rowIdx].ProductType == "Non-Fixed") {
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.Quantity*rows[e.rowIdx].FOBUnitPrice*weight),2).toFixed(2)});
            }
            else {
              let t = e.updated.Quantity*rows[e.rowIdx].FOBUnitPrice;
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.Quantity*rows[e.rowIdx].FOBUnitPrice),2).toFixed(2)});
            }
            Object.assign(rows[e.rowIdx], {TotalShippingWeight: roundTo(parseFloat(e.updated.Quantity*rows[e.rowIdx].ShippingWeight),2).toFixed(2), TotalNetWeight: roundTo(parseFloat(e.updated.Quantity*rows[e.rowIdx].NetWeight),2).toFixed(2)});
          }
          else if(e.updated.FOBUnitPrice != null && isNumber(e.updated.FOBUnitPrice) && e.updated.FOBUnitPrice > 0){
            let FOBUnitPrice = rows[e.rowIdx].FOBUnitPrice;
            Object.assign(rows[e.rowIdx], e.updated);
            if(rows[e.rowIdx].ProductType == "Per-Pound") {
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice*(parseFloat(rows[e.rowIdx].Quantity)||0)*weight),2).toFixed(2)});
            }
            else if(rows[e.rowIdx].ProductType == "Non-Fixed") {
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice*(parseFloat(rows[e.rowIdx].Quantity)||0)*weight),2).toFixed(2)});
            }
            else {
              Object.assign(rows[e.rowIdx], {TotalPrice: roundTo(parseFloat(e.updated.FOBUnitPrice*(parseFloat(rows[e.rowIdx].Quantity)||0)),2).toFixed(2)});
            }
          }
          else if (e.updated.FOBUnitPrice < 0) {
            alert("Unit Price is not allowed to be negative");
          }
          else if (e.updated.Quantity < 0) {
            alert("Quantity is not allowed to be negative");
          }
          else if(e.updated.Remark != null){
              Object.assign(rows[e.rowIdx], e.updated);
          }

          let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
          let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
          let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
          let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;
          let totalPrice = 0;
          let totalPriceForTax = 0;
          let totalPriceForAllLines = 0;
          let CRV = 0;
          let totalShippingWeight = 0;
          let totalNetWeight = 0;
          rows.map(row => {
            totalPrice += parseFloat(row["TotalPrice"]);
            totalPriceForAllLines += parseFloat(row["TotalPrice"]);
            if(row["IsTaxable"]) {
              totalPriceForTax += parseFloat(row["TotalPrice"]);
            }
            CRV += (Math.round(((parseFloat(row["CRV"]) || 0)*(parseFloat(row["Quantity"])||0))* 100) / 100);
            totalShippingWeight += (parseFloat(row["Quantity"]) || 0)*(parseFloat(row["ShippingWeight"]) || 0);
            totalNetWeight += (parseFloat(row["Quantity"]) || 0)*(parseFloat(row["NetWeight"]) || 0);
          })
          totalPrice = parseFloat(Math.round(totalPrice * 100) / 100).toFixed(2);
          totalPriceForTax = parseFloat(totalPriceForTax);
          totalPriceForAllLines = parseFloat(Math.round(totalPriceForAllLines * 100) / 100).toFixed(2);

          let finalPrice = (CRV + (Math.round(miscCostValue * 100) / 100) + (Math.round(adjustmentValue * 100) / 100) + (Math.round(handlingCostValue * 100) / 100) + (Math.round(shippingCostValue * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + (Math.round((totalPriceForTax * taxRate / 100.0) * 100) / 100));
          finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);

          totalShippingWeight = parseFloat(Math.round(totalShippingWeight * 100) / 100).toFixed(2);
          totalNetWeight = parseFloat(Math.round(totalNetWeight * 100) / 100).toFixed(2);
          let taxValue = parseFloat(taxRate || 0)*totalPriceForTax/100.0;
          taxValue = Math.round(0.0001 + taxValue * 100) / 100;
          this.props.setDefaultOfForm("TaxValue", taxValue, "purchaseOrderForm")

          this.setState({rows:rows,
            totalShippingWeight: totalShippingWeight,
            totalNetWeight: totalNetWeight,
            totalPrice: totalPrice,
            totalPriceForTax: totalPriceForTax,
            totalPriceForAllLines: totalPriceForAllLines,
            finalPrice: finalPrice,
            CRV
          });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNameFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.Name}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNumFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        const IsVariableFormatter = React.createClass({
            render() {
              return <span>
                      <Button
                        bsStyle="danger"
                        className="textAlignStyle"
                        style={{ height: '23px', width: '39px', padding: '0px' }}
                        onClick={ () => { moveOffFromProductsList(this.props.dependentValues.Product_id) } }
                      >
                          <Translate value="X" />
                      </Button>
                    </span>;
            }
        });

        // React Table Your Purchase Order

        const columns = [
          {
              key: 'Delete',
              name: <Translate value="del" />,
              formatter: IsVariableFormatter,
              width: 50,
              getRowMetaData: (row) => row
          },
          {
              key: 'Idx',
              name: <Translate value="idx" />,
              width: 35,
              resizable: false,
          },
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 70,
              filterable: true
          },
          {
              key: 'RefNum',
              name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
              resizable: true,
              sortable: true,
              width: 70,
              filterable: true,
          },
          {
              key: 'Name',
              name: <Translate value="prod_name" />,
              resizable: true,
              sortable: true,
              width: 200,
              filterable: true
          },
          {
              key: 'Description',
              name: <Translate value="desc" />,
              resizable: true,
              sortable: true,
              width: 95,
              filterable: true,
          },
          {
              key: 'Quantity',
              name: <Translate value="qty" />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 60,
              filterable: true,
              formatter: BoldTextFormatter,
          },
          {
              key: 'FOBUnitPrice',
              name: <Translate value="unit_dollarsign" />, //fix applied
              resizable: true,
              editable: true,
              sortable: true,
              width: 60,
              filterable: true,
              formatter: BoldCashFormatter,
          },
          {
              key: 'TotalPrice',
              name: <Translate value="total_dollarsign" />,
              resizable: true,
              sortable: true,
              width: 75,
              filterable: true,
              formatter: BoldCashFormatter,
          },
          {
              key: 'NetWeight',
              name: <Translate value="net_wt"/>,
              resizable: true,
              editable: false,
              sortable: true,
              width: 60,
              filterable: true,
          },
          {
              key: 'TotalNetWeight',
              name: <Translate value="total_wt" />,
              resizable: true,
              sortable: true,
              width: 70,
              filterable: true,
          },
          {
              key: 'PackageType',
              name: <Translate value="pkg_type" />,
              resizable: true,
              sortable: true,
              width: 70,
              filterable: true
          },
          {
              key: 'PackageSize',
              name: <Translate value="package_size" />,
              resizable: true,
              sortable: true,
              width: 80,
              filterable: true
          },
          {
              key: 'Remark',
              name: <Translate value="notation" />,
              resizable: true,
              width: 120,
              editable: true,
          }

        ];
        // this.props.products = this.props.products.bind(this);

        // Your Purchase Order React Table
        return (
            <Row>
              <Col xs={ 12 }>
                <div className="react-table-customizer" id="PurchaseOrderForm-dataGrid1">
                  <ReactDataGrid
                      rowKey='Product_id'
                      enableCellSelect={true}
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      headerRowHeight={45}
                      minHeight={this.state.yourOrderTableHeight}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      onRowClick={onRowClick}
                      onRowUpdated={handleRowUpdated}
                  />
                </div>
              </Col>
            </Row>
        )
    }
  }

  getAllProductNumOptions() {
    var productNumOptions = [{value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit"}];
    this.props.simplifiedProducts.map(product => {
        let text = "                                                                  ";
        let output = [product.ProductNum.slice(0, 8), text].join('');
        output = [output.slice(0,8), '  |  ', product.Name.slice(0,12), text].join('');
        if(product.Description)
          output = [output.slice(0,26), '  |  ', product.Description.slice(0,50), text].join('');
        else
          output = [output.slice(0,26), '  |  ', '                                                  ', text].join('');
        if(product.MeasureUnit)
          output = [output.slice(0,83), '  |  ', product.MeasureUnit.slice(0,10), text].join('');
        else
          output = [output.slice(0,83), '  |  ', '          ', text].join('');
        output = output.slice(0,99);
        productNumOptions.push({ value: product.Product_id, label: output})
    });
    return productNumOptions;
  }

  getProductNumOptions() {
    var productNumOptions = [{value: '', label: "No.       |  Name           |  Description                                           |  MeasureUnit"}];
    this.props.products.map(product => {
        let text = "                                                                  ";
        let output = [product.ProductNum.slice(0, 8), text].join('');
        output = [output.slice(0,8), '  |  ', product.Name.slice(0,12), text].join('');
        if(product.Description)
          output = [output.slice(0,26), '  |  ', product.Description.slice(0,50), text].join('');
        else
          output = [output.slice(0,26), '  |  ', '                                                  ', text].join('');
        if(product.MeasureUnit)
          output = [output.slice(0,83), '  |  ', product.MeasureUnit.slice(0,10), text].join('');
        else
          output = [output.slice(0,83), '  |  ', '          ', text].join('');
        output = output.slice(0,99);
        productNumOptions.push({ value: product.Product_id, label: output})
    });
    return productNumOptions;
  }

  // Dropdown list for payment status
  renderPaymentStatus() {
       let paymentStatusOptions = [
          { value: 'Not Paid', label: 'Not Paid' },
           { value: 'Partially Paid', label: 'Partially Paid' },
           { value: 'Paid', label: 'Paid' },
       ]

       return (
               <Col xs={ 6 }>
                 <label className="col-xs-6 inlineLabel" ><Translate value="payment_status" /> <span style={{color: 'red'}} >*</span> </label>
                  <Col xs={ 6 }>
                    <Field name="PaymentStatus" component={Selection} options={paymentStatusOptions}/>
                  </Col>
               </Col>
         )
  }

    getProductNameOptions() {
        var productNameOptions = [];
        this.props.products.map(product => {
            productNameOptions.push({ value: product.Product_id, label: product.Name })
        });
        return productNameOptions;
    }

    renderCarryTypeShippingMethod() {
        let carryTypeOptions = [
            { value: "Dry", label: "Dry" },
            { value: "Refrigerated", label: "Refrigerated" }
        ];
        let shippingMethodOptions = [
            { value: "Pickup", label: "Pickup" },
            { value: "Delivery", label: "Delivery" }
        ];
        return (
          <div>
            <Col xs={ 12 } id="shipping-method-field">
              <label>
                <Translate value="shipping_method" /><span className="asteriksReq">*</span>
              </label>
              <Field name="ShippingMethod" component={Selection} ref="shippingMethod" withRef={true}
              options={shippingMethodOptions}/>
            </Col>
            <Col xs={ 12 }>
              <label><Translate value="carry_type" /></label>
              <Field name="CarryType" component={Selection} ref="carryType" withRef={true}
                options={carryTypeOptions}/>
            </Col>
          </div>
        )
    }

    // Render the Paymentterms select.

    renderPaymentTerms() {
        let paymentTermOptions = []
        if (this.props.paymentTermsIsLoading) {
          paymentTermOptions = [{value:'loading', label:'loading'}]
        } // If group is loading, show a spinner.
        else {
            paymentTermOptions = this.getPaymentTermOptions();
        }
        return (
          <div className="form-group">
            <div className="col-xs-6">
              <Row></Row>
              <label className="set-line-height"><Translate value="payment_term" /></label>
            </div>
            <div className="col-xs-6 mt-lg">
              <Field name="PaymentTerm_id" component={DisabledSelection} options={paymentTermOptions}/>
            </div>
          </div>
        )
    }

    getPaymentTermOptions() {
        var paymentTermOptions = [];
        this.props.paymentTerms.map(paymentTerm => {
            paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
        });
        return paymentTermOptions;
    }

    // Implement the Headers which enable the function of collapsible

    productHeader() {
      return (
        <div>
          <h2 style={{ cursor: "pointer" }} ><Translate value="product_information" /></h2>
        </div>
      )
    }

    orderHeader() {
      const { currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
      let tableheader = ""
      if(this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) {
        tableheader = "your_purchase_order"
      }
      else if(this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote){
        tableheader = "your_purchase_quote"
      }
      else {
        tableheader = "your_purchase_template"
      }
      return (
        <div>
          <h2 style={{ cursor: "pointer" }} ><Translate value={tableheader}/></h2>
        </div>
      )
    }

    checkoutHeader() {
      return (
        <div>
          <h2 style={{ cursor: "pointer" }} ><Translate value="more_info" /></h2>
        </div>
      )
    }

    orderDetailHeader() {
      return (
        <div>
          <h4 style={{ cursor: "pointer" }} ><Translate value="PO_details" /></h4>
        </div>
      )
    }

    pickupHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="pickup" /></label>
        </div>
      )
    }

    deliverHeader() {
      return (
        <Row>
          <label style={{ cursor: "pointer" }} ><Translate value="deliver_warehouse" /></label>
        </Row>
      )
    }

    carryHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="carry_type_shipping_method" /></label>
        </div>
      )
    }

    accountHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="account_payment_term" /></label>
        </div>
      )
    }

    attachmentHeader() {
      return (
        <div>
          <label style={{ cursor: "pointer" }} ><Translate value="attachment_upload" /></label>
        </div>
      )
    }

    vendorHeader() {
        return (
          <h2 className="mt0"><Translate value="vendor_information" /></h2>
            // <div onClick={ ()=> this.setState({ vendorInformationOpen: !this.state.vendorInformationOpen })} >
            //     <h2 style={{ cursor: "pointer" }} ><Translate value="vendor_information" /></h2>
            // </div>
        )
    }

    oneTimeScheduleHeader(){
        return (
            <div onClick={ ()=> this.setState({ oneTimeScheduleOpen: !this.state.oneTimeScheduleOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="one_time_schedule" /></label>
            </div>
        )
    }

    purchaseInformationHeader(){
        return (
            <div onClick={ ()=> this.setState({ purchaseInformationOpen: !this.state.purchaseInformationOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="purchase_information" /></label>
            </div>
        )
    }

    orderHistoryHeader(){
        return (
            <div>
                <h4 className="marginHeader" style={{ cursor: "pointer" }} ><Translate value="order_history" /></h4>
            </div>
        )
    }

    inventoryHeader(){
        return (
            <div onClick={ ()=> this.setState({ inventoryOpen: !this.state.inventoryOpen })} >
                <label style={{ cursor: "pointer" }} ><Translate value="inventory" /></label>
            </div>
        )
    }

    onDrop(files) {
        this.setState({
            files: files
        });
    }

    onOpenClick() {
        this.refs.dropzone.open();
    }

    renderPreview() {
        return (
            <div>
              <h4><Translate value="preview" /></h4>
                <hr/>
                <Row><Col xs={ 12 }>
                    <Image src={this.state.files[0].preview} thumbnail/>
                </Col></Row>
            </div>
        )
    }

    renderWarehouse() {
        if (!this.props.warehouseIsLoading&& !this.props.warehouseError) {
        let warehouseOptions = this.getWarehouseOptions();
        if(!this.props.shippingMethod)
          return;
        else if(this.props.shippingMethod == "Delivery" || this.props.shippingMethod.value == "Delivery"){
          return (
                <Col xs={ 12 }>
                  <label><Translate value="deliver_warehouse" /> <span className="asteriksReq">*</span> </label>
                  <Field name="Deliver_Warehouse_id" component={Selection} ref="deliver_Warehouse_id" withRef={true}
                    options={warehouseOptions} />
                </Col>
          )
        }
        else return
        }
    }

    getWarehouseOptions() {
        var warehouseOptions = [];
        this.props.warehouses.map(warehouse => {
            warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
        });
        return warehouseOptions;
    }


    // If the user was directed to the page with a parameter,
    // then this page is edit page. Otherwise this is a create
    // page.

    handleFormSubmit() {
        let formProps = arguments[1];
        this.setState({ dirty: false });

        let quantityZero = this.state.rows.filter(function (obj) {
          return obj.Quantity == 0;
        })
        if (quantityZero.length > 0) {
          this.setState({ case: "zeroQuantity", confirmOpen: true, quantityZero });
          return;
        }
        if (this.state.totalPrice == 0){
          this.setState({ case: "zerototalPrice", confirmOpen: true});
          return;
        }

        if(arguments[0] == "dropship") {
          this.setState({orderInfo: formProps});
          this.openShowCustomer();
          // this.props.createDropship(formProps, Data.Selectors.getRows(this.state));
        }
        else if(arguments[0] == 'purchaseQuote'){
          if(!this.props.currentPurchaseQuote) this.props.createPurchaseQuote(formProps, this.state.rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice )
          else{
            if(!this.checkPermission("change_purchase_order"))
              this.props.editPurchaseQuote(formProps, Data.Selectors.getRows(this.state), this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice);
            else
              alert("You have no permission!");
          }
        }
        else if(arguments[0] == 'convert'){
          this.props.purchaseQuotePlace(formProps, Data.Selectors.getRows(this.state), this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice);
        }
        else if(arguments[0] == 'purchaseTemplate'){
          if(!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, this.state.rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice )
          else{
            if(!this.checkPermission("change_purchase_template")){
              const rows = Data.Selectors.getRows(this.state);
              this.props.editPurchaseTemplate(formProps, rows, this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice);
            }else
              alert("You have no permission!");
          }
        }
        else if (formProps.ShippingMethod === "Delivery" && !(formProps.Deliver_Warehouse_id)){
          alert("Please select a warehouse if your shipping method is delivery.");
        } else {
          if (!this.props.currentPurchaseOrder) this.props.createPurchaseOrder(formProps, this.state.rows, this.state.files, this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice);
          else {
            if(!this.checkPermission("change_purchase_order")){
              const rows = Data.Selectors.getRows(this.state);
              this.props.editPurchaseOrder(formProps, rows, this.state.files, this.state.taxRate, this.state.CRV, this.state.totalNetWeight,this.state.totalShippingWeight,this.state.totalPrice, this.state.finalPrice);
            }else
              alert("You have no permission!");
          }
        }
    }

    handleMiscCostChange(event) {
      let discountValue = parseFloat(this.state.discountValue) || 0;
      let taxRate = parseFloat(this.state.taxRate) || 0;

      let miscCostValue = event.target.value;
      let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
      let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
      let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;

      let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
      let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
      let CRV = this.state.CRV;
      let totalPrice = totalPriceForAllLines;
      totalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
      let finalPrice = ((parseFloat(CRV) || 0) + (parseFloat(miscCostValue) || 0) + adjustmentValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0);
      finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
      this.setState({miscCostValue, totalPrice, finalPrice});
    }

    handleHandlingCostChange(event) {
      let discountValue = parseFloat(this.state.discountValue) || 0;
      let taxRate = parseFloat(this.state.taxRate) || 0;

      let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
      let handlingCostValue = event.target.value;
      let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
      let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;

      let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
      let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
      let CRV = this.state.CRV;
      let totalPrice = totalPriceForAllLines;
      totalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
      let finalPrice = ((parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + (Math.round((parseFloat(handlingCostValue) || 0) * 100) / 100) + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0);
      finalPrice = (Math.round(finalPrice*100)/100).toFixed(2)
      this.setState({handlingCostValue, totalPrice, finalPrice});
    }

    handleShippingCostChange(event) {
      let discountValue = parseFloat(this.state.discountValue) || 0;
      let taxRate = parseFloat(this.state.taxRate) || 0;

      let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
      let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
      let shippingCostValue = event.target.value;
      let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;

      let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
      let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
      let CRV = this.state.CRV;
      let totalPrice = totalPriceForAllLines;
      totalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
      let finalPrice = ((parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + handlingCostValue + (Math.round((parseFloat(shippingCostValue) || 0) * 100) / 100) + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0);
      finalPrice = (Math.round(finalPrice*100)/100).toFixed(2)
      this.setState({shippingCostValue, totalPrice, finalPrice});
    }

    handleAdjustmentChange(event) {
      let discountValue = parseFloat(this.state.discountValue) || 0;
      let taxRate = parseFloat(this.state.taxRate) || 0;

      let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
      let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
      let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
      let adjustmentValue = event.target.value;

      let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
      let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
      let CRV = this.state.CRV;
      let totalPrice = totalPriceForAllLines;
      totalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
      let finalPrice = ((parseFloat(CRV) || 0) + (parseFloat(adjustmentValue) || 0) + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - discountValue / 100.0) + totalPriceForTax * taxRate / 100.0);
      finalPrice = (Math.round(finalPrice*100)/100).toFixed(2)
      this.setState({ adjustmentValue, totalPrice, finalPrice });
    }

    handleDiscountChange(event) {
      let discountValue = event.target.value;

      if (parseFloat(discountValue) < 0 || parseFloat(discountValue) > 100 || isNaN(discountValue)) {
        return;
      }

      let totalPrice = parseFloat(this.state.totalPrice) || 0;

      let taxRate = parseFloat(this.state.taxRate) || 0;

      let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
      let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
      let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
      let adjustmentValue = parseFloat(this.state.adjustmentValue) || 0;

      let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
      let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
      let CRV = this.state.CRV;
      let finalPrice = ((parseFloat(CRV) || 0) + adjustmentValue + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines * (1 - (Math.round((parseFloat(discountValue) || 0) / 100.0) * 100) / 100) + totalPriceForTax * taxRate / 100.0);
      finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
      this.setState({discountValue, finalPrice});
    }

    handleFocusAutoSuggest() {
      const autoSuggestField = document.getElementById('purchase-auto-suggest');
      autoSuggestField.focus();
      autoSuggestField.select();
     }

    // handleTaxChange(event) {
    //   let totalPrice = parseFloat(this.state.totalPrice) || 0;
    //
    //   let discountValue = parseFloat(this.state.discountValue) || 0;
    //   let taxRate = event.target.value;
    //
    //   let miscCostValue = parseFloat(this.state.miscCostValue) || 0;
    //   let handlingCostValue = parseFloat(this.state.handlingCostValue) || 0;
    //   let shippingCostValue = parseFloat(this.state.shippingCostValue) || 0;
    //
    //   let totalPriceForTax = parseFloat(this.state.totalPriceForTax) || 0;
    //   let totalPriceForAllLines = parseFloat(this.state.totalPriceForAllLines) || 0;
    //   let CRV = this.state.CRV;
    //   let finalPrice = ((parseFloat(CRV) || 0) + miscCostValue + handlingCostValue + shippingCostValue + totalPriceForAllLines*(1-discountValue/100.0) + totalPriceForTax*(parseFloat(taxRate)||0)/100.0);
    //   finalPrice = (Math.round(finalPrice*100)/100).toFixed(2);
    //   this.setState({taxRate, finalPrice});
    // }

    isDropship() {
      this.setState({type: "dropship", dirty: false});
    }

    isPurchaseOrder() {
      this.setState({type: "purchaseOrder", dirty: false});
    }

    isPurchaseQuote() {
      this.setState({type: "purchaseQuote", dirty: false});
    }

    placeNewOrder() {
      this.setState({type: "convert", dirty: false});
    }

    isPurchaseTemplate(){
      this.setState({type: "purchaseTemplate", dirty: false});
    }

    checkPermission(permission) {
        return false;
    }

    refreshPage(event) {
        event.preventDefault();
        if (this.props.purchaseOrderCreated || this.props.currentPurchaseOrder||this.props.purchaseOrderPlaced){
          const currentPurchaseOrder = this.props.purchaseOrderCreated || this.props.currentPurchaseOrder||this.props.currentPurchaseQuote;
          this.closeShowPOCreated();
          this.props.fetchPurchaseOrderDetail(currentPurchaseOrder.PurchaseOrder_id).then(() => {
            this.props.selectPurchaseOrder(currentPurchaseOrder);
            this.context.router.push('/purchaseOrder/'+currentPurchaseOrder.PurchaseOrder_id);
          });
        }
        else if (this.props.purchaseQuoteCreated || this.props.currentPurchaseQuote){
          const currentPurchaseQuote = this.props.purchaseQuoteCreated || this.props.currentPurchaseQuote;
          this.closeShowPOCreated();
          this.props.fetchPurchaseQuoteDetail(currentPurchaseQuote.PurchaseOrder_id).then(() => {
            this.props.selectPurchaseQuote(currentPurchaseQuote);
            this.context.router.push('/purchaseQuote/'+currentPurchaseQuote.PurchaseOrder_id);
          });
      }
      else if (this.props.purchaseTemplateCreated || this.props.currentPurchaseTemplate){
        const currentPurchaseTemplate = this.props.purchaseTemplateCreated || this.props.currentPurchaseTemplate;
        this.closeShowPOCreated();
        this.props.selectPurchaseTemplate(currentPurchaseTemplate);
        this.context.router.push('/purchaseTemplate/'+currentPurchaseTemplate.PurchaseTemplate_id);
      }
    }

    IFrameIsLoaded = () => {
      if (!this.state.PdfFrameLoaded) {
        var pdfFrame = window.frames["Pdf"];
        pdfFrame.focus();
        pdfFrame.print();
        this.setState({ PdfFrameLoaded: true });
      }
    }

    renderIFrame() {
      if (this.props.purchaseOrderPdf) {
        var file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
        return (
            <iframe style={{ display: 'none'}} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }

    renderPrint() {
      let currentPurchaseOrder = this.props.currentPurchaseOrder;
      if(!currentPurchaseOrder)
        return;
      let url = ROOT_URL + 'v1/purchase/order/print/' + currentPurchaseOrder.PurchaseOrder_id + "?Bearer=" + localStorage.getItem('token');
      return(
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printPurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
          }}
        >
          <em className="fa fa-print" />
          <Translate value="print_po" />
        </Button>
      )
    }

    renderPrintPickingList() {
      let currentPurchaseOrder = this.props.currentPurchaseOrder;
      if(!currentPurchaseOrder)
        return;
      let url = ROOT_URL + 'v1/purchase/order/pickupprint/' + currentPurchaseOrder.PurchaseOrder_id + "?Bearer=" + localStorage.getItem('token');
      return(
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printPickup(currentPurchaseOrder.PurchaseOrder_id);
          }}
        >
          <em className="fa fa-print" />
        <Translate value="print_pickup_list" />
        </Button>
      )
    }

    renderReset() {
      const {currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
      if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder){
        return(
          <Button
            bsStyle="danger"
            type="reset"
            onClick={() => { this.context.router.push('/purchaseOrder')}} >
            <em className="fa fa-close"/>
            <Translate value="cancel" />
          </Button>
      )
    }
    else if (this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote){
        return(
          <Button
            bsStyle="danger"
            type="reset"
            onClick={() => { this.context.router.push('/purchaseQuote')}} >
            <em className="fa fa-close"/>
            <Translate value="cancel" />
          </Button>
        )
      }
    else {
      return(
        <Button
          bsStyle="danger"
          type="reset"
          onClick={() => { this.context.router.push('/purchaseTemplate')}} >
          <em className="fa fa-close"/>
        </Button>
      )
    }
    }

  renderDropShipButton(handleSubmit) {
    const {currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
    const buttonOnClick = (type) => _.throttle(handleSubmit((data) => { 
      this.handleFormSubmit(type, data);
    }), 5000, { trailing: false });
    if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder){
      return(
        <Button
          bsStyle="warning"
          type="button"
          disabled={(this.state.rows == 0)}
          onClick={buttonOnClick('dropship')} >
          <em className="fa fa-truck" />
          <Translate value="dropship" />
        </Button>
      );
    } else if (currentPurchaseQuote) {
      return(
        <Button
          bsStyle="warning"
          type="button"
          onClick={buttonOnClick('convert')} >
          <em className="fa fa-pencil" />
          <Translate value="ConvertPO" />
        </Button>
      );
    }
    return;
  }

  renderSave() {
    const { 
      currentPurchaseOrder, 
      currentPurchaseQuote, 
      currentPurchaseTemplate, 
      handleSubmit,
      isCreating,
      isEditing,
    } = this.props;
    let formType;
    if (this.context.router.routes[1].path == "purchaseOrder/new" || currentPurchaseOrder) { 
      formType = 'purchaseOrder';
    } else if (this.context.router.routes[1].path == "purchaseQuote/new" || currentPurchaseQuote) {
      formType = 'purchaseQuote';
    } else {
      formType = 'purchaseTemplate';
    }
    const buttonOnClick = _.throttle(handleSubmit((data) => { 
      this.handleFormSubmit(formType, data) 
    }), 5000, { trailing: false });
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={(this.state.rows == 0) || isCreating || isEditing}
        onClick={buttonOnClick}
      >
        <em className="fa fa-save" />
        <Translate value="save" />
      </Button> 
    );
  }

    renderSubtotal() {
      let subtotal = 0
      if (this.state.selectedInventoryRow.ProductType == "Fixed") {
        if (this.props.allProdQuantity) {
          subtotal = (Math.round(this.props.allProdQuantity * this.props.allProdFOBUnitPrice *10000)/10000).toFixed(2);
          // return(
          //   <Col xs={ 12 }>${(Math.round(this.props.allProdQuantity * this.props.allProdFOBUnitPrice *10000)/10000).toFixed(2)}</Col>
          // )
        }
      } else {
        if (this.props.weight) {
          subtotal = (Math.round(this.props.allProdFOBUnitPrice * this.props.weight * this.props.allProdQuantity * 10000)/10000).toFixed(2);
          // return (
          //   <Col xs={ 12 }>${(Math.round(this.props.allProdFOBUnitPrice * this.props.weight * this.props.allProdQuantity * 10000)/10000).toFixed(2)}</Col>
          // )
        }
      }
      // this.props.setValue('purchaseOrderForm', 'Subtotal', subtotal);
      return (
        <Field name="Subtotal" component={ DisabledInputField } placeholder={subtotal}/>
      )
    }

    renderVendorProducts() {
      if (this.props.productIsLoading && !this.props.productError) return <Spinner/>
      else if (this.props.productError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.productError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.vendorProducts);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          const onRowsSelected = (rows) => {
              let newRows = getRows();
              let selectedIndexes = this.state.vendorProducts.selectedIndexes.concat(rows.map(r => r.rowIdx))
              rows.map (r => {
                newRows[r.rowIdx].isSelected = true;
              });
              let vendorProducts = {...this.state.vendorProducts, rows: newRows, selectedIndexes: selectedIndexes};
              this.setState({ vendorProducts });
          }

          const onRowsDeselected = (rows) => {
              let rowIndexes = rows.map(r => r.rowIdx);
              let newRows = getRows();
              let selectedIndexes = this.state.vendorProducts.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1 );
              rows.map (r => {
                newRows[r.rowIdx].isSelected = false;
              });
              let vendorProducts = {...this.state.vendorProducts, rows: newRows, selectedIndexes: selectedIndexes};
              this.setState({ vendorProducts });
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var vendorProducts = {...this.state.vendorProducts, sortColumn: sortColumn, sortDirection: sortDirection};
              this.setState({vendorProducts});
          }

          const onRowSelect = rows => {
              var previousOrderes = {...this.state.vendorProducts, selectedRows: rows};
              this.setState({vendorProducts});
          }

          const onRowClick = (rowIdx, row) => {
            if(rowIdx > -1) {
              this.props.fetchProductInfo(row.Product_id);
            }
          }

          //Custom Formatter component
          const IsEnabledFormatter = React.createClass({
              render() {
                  if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                  else return <span className="label label-danger"><Translate value="disable" /></span>;
              }
          });

          // Vendor Products Columns

          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true
            },
            {
                key: 'RefNum',
                name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
                resizable: true,
                sortable: true,
                width: 70,
                filterable: true,
            },
            {
                key: 'Name',
                name: <Translate value="prod_name" />,
                resizable: true,
                sortable: true,
                width: 300,
                filterable: true
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 200,
                filterable: true,
            },
            {
                key: 'ProductCost',
                name: <Translate value="unit_dollarsign"  />,
                resizable: true,
                editable: true,
                sortable: true,
                width: 70,
                filterable: true,
                formatter: BoldCashFormatter,
            },
            {
                key: 'MeasureUnit',
                name: <Translate value="measure_unit" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterable: true
            },
            {
                key: 'PackageType',
                name: <Translate value="pkg_type" />,
                resizable: true,
                sortable: true,
                width: 80,
            },
            {
                key: 'NetWeight',
                name: <Translate value="net_wt" />,
                resizable: true,
                editable: true,
                sortable: true,
                width: 65,
                filterable: true,
            }
          ]
          // Vendor Products React Table
          return (
              <Row>
                <Col xs={ 12 }>
                  <div className="react-table-customizer" id="PurchaseOrderForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='Product_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        headerRowHeight={45}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        enableRowSelect='multi'
                        minHeight={205}
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect}
                        onRowClick={onRowClick}
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }} />
                  </div>
                </Col>
              </Row>
          )
      }
    }

    renderOrderHistory() {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.productInfos);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
            {
                key: 'Quantity',
                name: <Translate value="qty" />,
                resizable: true,
                sortable: true,
                width: 40,
            },
            {
                key: 'UnitPrice',
                name: <Translate value="unit_dollarsign" />,
                resizable: true,
                sortable: true,
                width: 50,
                formatter: BoldCashFormatter,
            },
            {
                key: 'OrderDate',
                name: <Translate value="dop" />,
                resizable: true,
                sortable: true,
                width: 80,
                formatter: DateFormatter,
            },
          ]

          return (
              <Row><Col xs={ 12 }><div style={{ maxWidth: '100%' }} id="PurchaseOrderForm-dataGrid3">
                  <ReactDataGrid
                      rowKey='Product_id'
                      columns={columns}
                      rowHeight={25}
                      headerRowHeight={45}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      minHeight={150}
                  />
                  </div></Col></Row>
          )
    }
    renderOrderDatePiece() {
      const {currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate } = this.props;
      if (this.context.router.routes[1].path == "purchaseTemplate/new" || currentPurchaseTemplate&&this.context.router.routes[1].path != "purchaseQuote/new"){
        return(
          <Col xs={ 3 } id="purchase-template_name">
            <h4><Translate value="purchase_template_info" /></h4>
            <div className="form-group">
              <label className="col-xs-4">
                <Translate value="create_date" />
              </label>
              <div className="col-xs-8">
                <Field name="CreateTime" selected={new Date()}  component={DisabledDatePicker} />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4">
                <Translate value="last_update" />
              </label>
              <div className="col-xs-8">
                <Field name="UpdateTime" selected={new Date()} component={DisabledDatePicker} />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 line-height">
                <Translate value="name" /><span className="asteriksReq">*</span>
              </label>
              <div className="col-xs-8">
                <Field name="Name" className="set-height" component={InputField} placeholder="Template Name" />
              </div>
            </div>
          </Col>
        )
      }
      else{
        let minDate = new Date();
        if(this.props.orderDate) {
          minDate = new Date(this.props.orderDate)
        }
        return(
        <Col xs={ 3 } id="purchase-order-dates">
          <h4><Translate value="purchase_order_dates" /></h4>
          <div className="form-group">
            <label className="col-xs-4">
              <Translate value="ordered" />
            </label>
            <div className="col-xs-8">
              <Field name="OrderDate" selected={new Date()} component={DatePicker} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-4">
              <Translate value="eta_date" />
            </label>
            <div className="col-xs-8">
              <Field name="ETADate" selected={new Date()} minDate={minDate} component={DatePicker} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-4">
              <Translate value="received" />
            </label>
            <div className="col-xs-8">
              <Field name="ReceivedDate" component={DatePicker} />
            </div>
          </div>
        </Col> )
    }
  }

    renderAutoSuggest() {
      return (
        <PurchaseOrderAutoSuggest
          value={this.state.suggestValue}
          onChange={(e, { newValue }) => { this.clearInventoryInfo(); this.props.resetAllProducts('purchaseOrderForm'); this.setState({ suggestValue: newValue }); }}
          handleKeyPress={this.handleKeyPress}
          handleFocusQty={this.handleFocusQty}
          setAllProductQuantity={this.setAllProductQuantity}
          SearchType={this.props.searchType}
        />
      );
    }

    formTitle() {
        if (this.props.purchaseOrderCreated || this.props.purchaseOrderPlaced||this.props.purchaseOrderEdited ) return <Translate value="msg_purchase_order_saved" />;
        else if (this.props.purchaseOrderEdited&&this.props.currentPurchaseOrder) return <Translate value="msg_purchase_order_saved" />;
        else if (this.props.purchaseQuoteCreated ||this.props.purchaseQuoteEdited ) return <Translate value="msg_purchase_quote_saved" />;
        else if (this.props.purchaseTemplateCreated || this.props.purchaseTemplateEdited) return <Translate value="msg_purchase_template_saved" />;
        else return <Translate value="msg_operation_saved" />;
    }

    render() {
        let productNumOptions = this.getProductNumOptions();
        let allProductNumOptions = this.getAllProductNumOptions();
        let createDialogStyle = {
            height: '600px',
            marginTop: '-20%',
            width: '680px',
            marginLeft: '-10%',
            left: '45%',
        };

        let createDialogInventoryStyle = {
          height: '700px',
          width: '1000px',
          marginLeft: '-28%',
          marginTop: '-20%',
        };
        const { handleSubmit, submitting, pristine,currentPurchaseOrder, currentPurchaseQuote,currentPurchaseTemplate, error } = this.props;
        const renderVendorProducts = (<Translate value="vendor_products" />);
        const renderAllProducts = (<Translate value="all_products" />);
        const confirmAction = (<Translate value="confirm_action" />);
        const PODetails = (<Translate value="po_details" />);
        const CheckoutInfo = (<Translate value="more_info" />);
        const changeTax = (<Translate value="choose_tax_rate" />);
        const convertItemPriceTranslation = (<Translate value="type" />);
        let activeBreadcrumb = ""
        if (this.context.router.routes[1].path == "purchaseOrder/new"){
          activeBreadcrumb = "new_purchase_order";
        }
        else if(currentPurchaseOrder){
          activeBreadcrumb = "edit_purchase_order"
        }
        else if(currentPurchaseQuote){
          activeBreadcrumb = "edit_purchase_quote"
        }
        else if(this.context.router.routes[1].path == "purchaseQuote/new"){
          activeBreadcrumb = "new_purchase_quote"
        }
        else if(currentPurchaseTemplate){
          activeBreadcrumb = "edit_purchase_template"
        }
        else{
          activeBreadcrumb = "new_purchase_template"
        }
        let minDate = new Date();
        if(this.props.orderDate) {
          minDate = new Date(this.props.orderDate)
        }
        // if (this.props.detailIsLoading || this.props.vendorIsLoading || this.props.paymentTermsIsLoading) return <ContentWrapper><h5>...<Translate value="reading_data" /></h5></ContentWrapper>
        if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{this.props.detailError}</div></ContentWrapper>
        else {
          let productInfo = this.state.productInfo;
          let PONum = null, PurchaseStatus = null;
          if(this.props.currentPurchaseOrder){
            PONum = this.props.currentPurchaseOrder.PONum;
            PurchaseStatus = this.props.currentPurchaseOrder.PurchaseStatus;
          }
          let ProductType = this.state.ProductType;
          let CRV = this.state.CRV;
          let currentVendorDetail = this.props.currentVendorDetail;
          let contact = null;
          let phone = null;
          if(currentVendorDetail && currentVendorDetail.Billing) {
            contact = currentVendorDetail.Billing.FirstName + " " + currentVendorDetail.Billing.LastName
            phone = currentVendorDetail.Billing.Telephone
          }

            return (
                //---------------
                // Begin HTML
                //---------------
                <ContentWrapper>

                  {/* Form Wrapper: Makes Entire Page an Active Form */}
                  <form className="form-horizontal" method="get" action="#"  autoComplete="off">


                    {/* Navigation Trail */}
                    <Breadcrumb>
                      <Breadcrumb.Item>
                        <Translate value="purchase_management" />
                      </Breadcrumb.Item>
                      <Breadcrumb.Item active="true">
                        <Translate value={activeBreadcrumb} />
                      </Breadcrumb.Item>
                    </Breadcrumb> {/* End Navigation Trail */}

                    {/* Button actions for this page */}
                    <ButtonToolbar>
                      { this.renderSave() }
                      {/* <Button
                        bsStyle="primary"
                        type="button" >
                        <em className="fa fa-fax"/>
                        <Translate value="e_fax" />
                      </Button>
                      <Button
                        bsStyle="primary"
                        type="button" >
                        <em className="fa fa-envelope-o" />
                        <Translate value="email" />
                      </Button> */}
                      {this.renderPrint()}
                      {this.renderPrintPickingList()}
                      {/* {this.renderDropShipButton(handleSubmit)}  */} {/* Temperarily disable dropship since it does not work */}
                      {this.renderReset()}
                    </ButtonToolbar>

                    <Grid id="create-new-purchase-order">
                      {/* Row Wrapper */}
                      <Row>
                        {/* If loading */}
                        <Col xs={6}>
                            {error && <div className="alert alert-danger marginTopStyle" >{error}</div>}
                            { (this.props.isCreating || this.props.isEditing || this.props.isPlacing ) && <Spinner/> }
                            { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
                            { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
                            { this.props.placeError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.placeError)}</div> }
                        </Col> {/* End If */}

                        {/* Main Workspace */}
                        <Col xs={ 10 }>

                          {/* Vendor Details  */}
                          <Row>
                            {this.vendorHeader()}
                            <fieldset className="form-horizontal">
                            <Panel id="purchase-order-vendor-info">
                              <Row>
                                {/* Vendor Information */}
                                {this.renderVendorsDetail() }

                                {/* Billing Information */}
                                <Col xs={3} id="billing-info">
                                  <h4><Translate value="billing_information" /></h4>
                                  <div className="form-group">
                                    <label className="col-xs-3">
                                      <Translate value="contact" />:
                                    </label>
                                    <div className="col-xs-9">
                                      <Row>
                                        {!this.props.currentVendorDetail && <div className="col-xs-9">
                                          <Translate value="msg_please_select_a_vendor" />
                                        </div>}
                                        {this.props.currentVendorDetail && contact}
                                      </Row>
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-3">
                                      <Translate value="phone" />:
                                    </label>
                                    <div className="col-xs-9">
                                      <Row>
                                        {!this.props.currentVendorDetail && <div className="col-xs-9">
                                          <Translate value="" />
                                        </div>}
                                        {this.props.currentVendorDetail && phone}
                                      </Row>
                                    </div>
                                  </div>
                                  <div className="form-group mb0">
                                    <label className="col-xs-3">
                                      <Translate value="address" />:
                                    </label>
                                    {this.props.currentVendorDetail &&
                                      <div className="col-xs-9">
                                        <Row>
                                          {this.renderBillingAddress1()}
                                        </Row>
                                        <Row>
                                          {this.renderBillingAddress2()}
                                        </Row>
                                      </div> }
                                  </div>
                                </Col> {/* End Billing Information */}

                                {/* Purchase Order Dates
                                <Col xs={ 3 } id="purchase-order-dates">
                                  <h4><Translate value="purchase_order_dates" /></h4>
                                  <div className="form-group">
                                    <label className="col-xs-4">
                                      <Translate value="ordered" />
                                    </label>
                                    <div className="col-xs-8">
                                      <Field name="OrderDate" selected={new Date()} component={DisabledDatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-4">
                                      <Translate value="eta_date" />
                                    </label>
                                    <div className="col-xs-8">
                                      <Field name="ETADate" selected={new Date()} minDate={minDate} component={DatePicker} />
                                    </div>
                                  </div>
                                  <div className="form-group">
                                    <label className="col-xs-4">
                                      <Translate value="received" />
                                    </label>
                                    <div className="col-xs-8">
                                      <Field name="ReceivedDate" minDate={minDate} component={DatePicker} />
                                    </div>
                                  </div>
                                </Col> Purchase Order Dates */}
                                {this.renderOrderDatePiece()}
                                <Col xs={2}>
                                  <Row>
                                    <Col xs={12}>
                                      <Row className='form-group' style={{ marginLeft: '0', marginBottom: '14px', paddingTop: '26px' }}>
                                        <Col xs={6}>
                                          <label><Translate value="created" />:  </label>
                                        </Col>
                                        <Col xs={6}>
                                          {this.state.created_by}
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col xs={12}>
                                      <Row className='form-group' style={{ marginLeft: '0', marginBottom: '10px'}}>
                                        <Col xs={6}>
                                          <label><Translate value="modified" />: </label>
                                        </Col>
                                        <Col xs={6}>
                                          {this.state.modified_by}
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col xs={12}>
                                      <Row className='form-group' style={{ marginLeft: '0' }}>
                                        <Col xs={6}>
                                          <label><Translate value="modified_on" />: </label>
                                        </Col>
                                        <Col xs={6}>
                                          {this.state.updateTime}
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Panel>
                          </fieldset>
                          </Row> {/* End Vendor Informoation  */}

                          {/* Product Information */}
                          <Row>
                              {this.productHeader()}
                              <Tabs activeKey={ this.state.yourOrderKey } justified onSelect={this.handleSelect}>
                                <Tab eventKey={ 1 } title={renderVendorProducts}>
                                  <div className="tab-products-table">
                                    <Button
                                      bsStyle="primary"
                                      className="position-btn"
                                      type="button"
                                      onClick={() => {this.moveToProductsList()}}>
                                      <em className="fa fa-plus" />
                                      {/* <Translate value="move_to_po" /> */}
                                    </Button>

                                    {/* Vendor Products Tab */}
                                    { this.renderVendorProducts() }
                                  </div>

                                  {/* Inventory Details */}
                                  <Row id="inventory-details">
                                    <Col xs={ 6 }>
                                      <Col xs={ 4 }>
                                        <label className="inventory-label"><Translate value="inventory" /><span className="colon">:</span></label>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="in_stock" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.InStock:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="presale" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.PreSale:null}</span>
                                      </Col>
                                    </Col>
                                    <Col xs={ 6 }>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="purchased" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.Purchased:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="min_limit" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo && productInfo.ProductNum ? productInfo.ProductNum.MinStockRange:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="max_limit" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo && productInfo.ProductNum ? productInfo.ProductNum.MaxStockRange:null}</span>
                                      </Col>
                                    </Col>
                                  </Row>{/* End Inventory */}
                                </Tab>
                                <Tab eventKey={ 2 } title={renderAllProducts}>
                                  <Row>
                                    {/* Search Product by */}
                                    <Col xs={ 6 } className="p0">
                                      <Field name="searchType" component={ renderTypeRadios } />
                                      {/*<Field name="AllProducts" ref="allProducts" withRef={true} component={ InputField } options={allProductNumOptions} onKeyPress={(event) => {this.openShowInventory(event)}} onFocus={this.handleOnFocus} />*/}
                                      {this.renderAutoSuggest()}
                                    </Col>
                                    <Col xs={ 6 } id="product-search-outputs">
                                      <Col xs={ 2 }>
                                        <label>
                                          <Translate value="qty" />
                                        </label>
                                        <Field name="AllProd_Quantity" ref="allProd_Quantity" withRef={true} component={ InputField } placeholder={0} onKeyPress={(event) => {this.handleKeyPress("allProd_FOBUnitPrice", event)}} onFocus={this.handleOnFocus}/>
                                      </Col>
                                      <Col xs={ 2 } className="pl">
                                        <label>
                                          <Translate value="unit" /><span className="dollar-sign">$$</span>
                                        </label>
                                        <Field
                                          name="AllProd_FOBUnitPrice"
                                          ref="allProd_FOBUnitPrice"
                                          withRef={true}
                                          component={ InputField }
                                          placeholder={ "must be > 0" }
                                          onKeyPress={(event) => {
                                            if (event.charCode == 13) {
                                              if (!isNumber(this.props.allProdQuantity) || this.props.allProdQuantity < 0 || !isNumber(this.props.allProdFOBUnitPrice) || this.props.allProdFOBUnitPrice < 0){
                                                return;
                                              }
                                              this.handleFocusAutoSuggest();
                                              this.setAllProductQuantity(0);
                                              this.moveToProductsListFromAll();
                                            }
                                          }}
                                          onFocus={this.handleOnFocus}
                                        />
                                      </Col>
                                      <Col xs={ 2 }>
                                        <label>
                                          <Translate value="sale" /><span className="dollar-sign">$$</span>
                                        </label>
                                        <Field name="RefSalePrice" component={ DisabledInputField } />
                                      </Col>
                                      <Col xs={ 2 }>
                                        <label>
                                          <Translate value="net_wt" />
                                        </label>
                                        <Field name="Weight" component={ DisabledInputField } />
                                      </Col>
                                      <Col xs={ 2 }>
                                        <label>
                                          <Translate value="subtotal" />
                                        </label>
                                        {this.renderSubtotal()}
                                      </Col>
                                      <Col xs={ 2 }>
                                        <label>
                                          <Translate value="notation" />
                                        </label>
                                        <Field
                                          name="AllProd_Remark"
                                          ref="allProd_Remark"
                                          withRef={true}
                                          component={InputField}
                                          onKeyPress={(event) => {
                                            if (event.charCode == 13) {
                                              if (!isNumber(this.props.allProdQuantity) || 
                                                this.props.allProdQuantity < 0 || 
                                                !isNumber(this.props.allProdFOBUnitPrice) || 
                                                this.props.allProdFOBUnitPrice < 0) {
                                                return;
                                              }
                                              this.handleFocusAutoSuggest();
                                              this.setAllProductQuantity(0);
                                              this.moveToProductsListFromAll();
                                            }
                                          }}
                                          onFocus={this.handleOnFocus}
                                        />
                                      </Col>
                                    </Col>
                                  </Row>{/* End Search Product By */}

                                  {/* Inventory Details */}
                                  {/* Inventory Details */}
                                  <Row id="inventory-details">
                                    <Col xs={ 6 }>
                                      <Col xs={ 4 }>
                                        <label className="inventory-label"><Translate value="inventory" /><span className="colon">:</span></label>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="in_stock" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.InStock:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="presale" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.PreSale:null}</span>
                                      </Col>
                                    </Col>
                                    <Col xs={ 6 }>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="purchased" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo ? productInfo.Purchased:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="min_limit" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo && productInfo.ProductNum ? productInfo.ProductNum.MinStockRange:null}</span>
                                      </Col>
                                      <Col xs={ 4 }>
                                        <label className="col-xs-6 inlineLabel"><Translate value="max_limit" />:</label>
                                        <span className="col-xs-6 inventory-highlight">{productInfo && productInfo.ProductNum ? productInfo.ProductNum.MaxStockRange:null}</span>
                                      </Col>
                                    </Col>
                                  </Row>{/* End Inventory */}
                                </Tab>
                              </Tabs>
                          </Row> {/* End Product Information */}

                          {/* Your Purchase Order Table */}
                          <Row>
                            { this.orderHeader() }
                              <Panel>
                                { this.renderProducts() }
                              </Panel>
                          </Row> {/* End Your Purchase Order Table */}

                        </Col> {/* End Main Workspace */}

                        {/* PO Details Pane */}
                        <Col xs={ 2 } className="po-details-pane">
                          <Tabs defaultActiveKey={ 1 } justified className="tab-width-fix" >
                            <Tab eventKey={ 1 } title={PODetails} className="po-details-tab">
                            {/*  { this.orderDetailHeader() } */}
                            <Row>
                              <Col xs={ 4 } className="po-no-line-height">
                                <label><Translate value="po_num" /></label>
                              </Col>
                              <Col xs={ 8 }>
                                <Field name="PONum" component={ DisabledInputField } placeholder={ PONum }/>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={ 4 } className="status-line-height">
                                <label><Translate value="status" /></label>
                              </Col>
                              <Col xs={ 8 }>
                                <Field name="PurchaseStatus" component={ DisabledInputField } placeholder={PurchaseStatus}/>
                              </Col>
                            </Row>
                            <Row>
                              { this.renderCarryTypeShippingMethod() }
                              { this.renderVendorAddress() }
                              { this.renderWarehouse() }
                              <Col xs={ 6 }>
                                <label><Translate value="shipping" /><span className="dollar-sign">$$</span></label>
                                <Field name="ShippingCost" ref="shippingCost" withRef={true} component={ ControlledInputField } placeholder={this.state.shippingCostValue}
                                  onChange={this.handleShippingCostChange} onKeyPress={(event) => {this.handleKeyPress("handlingCost", event)}} onFocus={this.handleOnFocus}/>
                              </Col>
                              <Col xs={ 6 }>
                                <label><Translate value="handling" /><span className="dollar-sign">$$</span></label>
                                <Field name="HandlingCost" ref="handlingCost" withRef={true} component={ ControlledInputField } placeholder={this.state.handlingCostValue}
                                  onChange={this.handleHandlingCostChange} onKeyPress={(event) => {this.handleKeyPress("miscCost", event)}} onFocus={this.handleOnFocus}/>
                              </Col>
                              <Col xs={ 6 }>
                                <label><Translate value="misc" /><span className="dollar-sign">$$</span></label>
                                <Field name="MiscCost" ref="miscCost" withRef={true} component={ ControlledInputField } placeholder={this.state.miscCostValue}
                                  onChange={this.handleMiscCostChange} onKeyPress={(event) => {this.handleKeyPress("priceAdjustment", event)}} onFocus={this.handleOnFocus}/>
                              </Col>
                              <Col xs={6}>
                                <label><Translate value="adjustments" /><span className="dollar-sign">$$</span></label>
                                <Field
                                  name="PriceAdjustment"
                                  ref="priceAdjustment"
                                  withRef
                                  component={ControlledInputField}
                                  placeholder={this.state.adjustmentValue}
                                  onChange={this.handleAdjustmentChange}
                                  onKeyPress={(event) => { this.handleKeyPress("miscNote", event); }}
                                  onFocus={this.handleOnFocus}
                                />
                              </Col>
                              <Col xs={12}>
                                <label><Translate value="misc_detail" /></label>
                                <Field name="MiscNote" ref="miscNote" withRef={true} component={ InputField } onKeyPress={(event) => {this.handleKeyPress("discount", event)}} onFocus={this.handleOnFocus}/>
                              </Col>
                              <Col xs={ 4 } style={{"visibility": "hidden"}}>
                                <label><Translate value="disc" />%</label>
                                <Field name="Discount" ref="discount" withRef={true} component={ ControlledInputField } placeholder={this.state.discountValue}
                                  onChange={this.handleDiscountChange} onKeyPress={(event) => {this.handleKeyPress("taxValue", event)}} onFocus={this.handleOnFocus}/>
                              </Col>
                              <Col xs={ 4 }>
                                <label><Translate value="tax" /><span className="dollar-sign">$</span></label>
                                <span onDoubleClick={()=>{this.openChangeTax()}}><Field name="TaxValue" ref="taxValue" withRef={true} component={ DisabledInputField } /></span>
                              </Col>
                              <Col xs={ 4 }>
                                <label><Translate value="crv" /><span className="dollar-sign">$</span></label>
                                <Field name="CRV" component={ DisabledInputField } placeholder={CRV} />
                              </Col>
                              <Col xs={ 12 }>
                                { this.renderPaymentTerms() }
                              </Col>
                            </Row>

                            <Row className="sale-details-output">
                              <Field name="IsDropship" component={ renderRadios } />
                              <Col xs={ 12 }>
                                <Row>
                                  <Field name="ConvertItemPrice" component={ ConvertItemPrice } labelName={ convertItemPriceTranslation }/>
                                </Row>
                              </Col>
                              <Col xs={ 12 }>
                                <Row>
                                  <Col xs={ 6 }>
                                    <label><Translate value="total_net_wt" /></label>
                                  </Col>
                                  <Col xs={ 6 }>
                                    <label>{this.state.totalNetWeight} lb</label>
                                      {/*}<Field name="FinalNetWeight" component={ HiddenInputField } V={taxRate }/>*/}
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={ 12 }>
                                <Row>
                                  <Col xs={ 6 }>
                                    <label><Translate value="total_ship_wt" /></label>
                                  </Col>
                                  <Col xs={ 6 }>
                                    {/*<Field name="FinalShippingWeight" component={ HiddenInputField } V={ this.state.totalShippingWeight }/>*/}
                                    <label>{this.state.totalShippingWeight} lb</label>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={ 12 }>
                                <Row className="pricing-highlight">
                                  <Col xs={ 6 }>
                                    <label><Translate value="total" /><span className="dollar-sign">$$</span></label>
                                  </Col>
                                  <Col xs={ 6 }>
                                    <label><span className="dollar-sign">$</span> {this.state.totalPrice}</label>
                                    {/*<Field name="TotalPrice" component={ HiddenInputField } V={ this.state.totalPrice } />*/}
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs={ 12 }>
                                <Row className="pricing-highlight">
                                  <Col xs={ 6 }>
                                    <label><Translate value="final" /><span className="dollar-sign">$$</span></label>
                                  </Col>
                                  <Col xs={ 6 }>
                                    <label><span className="dollar-sign">$</span> {this.state.finalPrice}</label>
                                    {/*<Field name="FinalPrice" component={ HiddenInputField } V={ this.state.finalPrice }/>*/}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <fieldset>
                              {this.orderHistoryHeader()}
                              <div>
                                { this.renderOrderHistory()}
                              </div>
                            </fieldset>
                          </Tab>
                          {/*
                          <Tab eventKey={ 2 } title={CheckoutInfo} className="po-checkout-tab">
                            <Row id="checkout-information">
                              <Col xs={ 12 }>
                                <label><Translate value="created" />: {this.state.created_by}</label>
                              </Col>
                              <Col xs={ 12 }>
                                <label><Translate value="modified" />: {this.state.modified_by}</label>
                              </Col>
                              <Col xs={ 12 }>
                                <label><Translate value="modified_time" />: {this.state.updateTime}</label>
                              </Col>
                              <Col xs={ 12 }>
                                <h4><Translate value="note" /></h4>
                                <Field name="NoteToVendor" component="Textarea" className="form-control" style={{ minHeight: '100px' }}/>
                              </Col>
                              <Col xs={ 12 } className="mt">
                                <label><Translate value="outstanding_order" /></label>
                                <Field name="Outsanding" component={ DisabledInputField } />
                              </Col>
                              <Col xs={12} className="mt">
                                <label><Translate value="outstanding_invoice" /></label>
                                <Field name="OutstandingInvoice" component={ DisabledInputField } />
                              </Col>
                            </Row>
                          </Tab>
                          */}
                        </Tabs>
                        </Col> {/* End PO Details Pane */}
                      </Row> {/* Row Wrapper */}
                    </Grid>
                    {this.renderIFrame()}
                    {/* Customer List */}
                    <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showCustomerOpen} onCloseClicked={
                        this.closeShowCustomer} title="select customer information">
                        <CustomerInfo orderLineInfo={Data.Selectors.getRows(this.state)} orderInfo={this.state.orderInfo} totalNetWeight={this.state.totalNetWeight}
                        totalShippingWeight={this.state.totalShippingWeight} totalPrice={this.state.totalPrice} finalPrice={this.state.finalPrice} closeShowCustomer={this.closeShowCustomer} />
                    </SkyLightStateless> {/* End Customer List */}

                    {/* Inventory List */}
                    <SkyLightStateless dialogStyles={createDialogInventoryStyle} isVisible={this.state.showInventoryOpen} onCloseClicked={
                        this.closeShowInventory} title="Select Inventory">
                        <InventoryInfo searchValue={this.props.allProducts} searchType={this.props.searchType} form="purchaseOrderForm"
                          closeShowInventory={this.closeShowInventory} selectInventoryInfo={this.selectInventoryInfo} setAllProducts={this.props.setAllProducts} setAllProductQuantity={this.setAllProductQuantity} formName="purchaseOrderForm"/>
                    </SkyLightStateless> {/* End Inventory List */}

                    {/* PO Create Open */}
                    <div className="remove-close-skylight">
                      <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showPOCreatedOpen} onCloseClicked={
                          this.closeShowPOCreated} title={this.formTitle() } >
                          <br/><br/>
                          <Row className="centerStyle">
                            { this.props.purchaseOrderCreated && <h4><Translate value="msg_purchase_order_num_is" />: {this.props.purchaseOrderCreated.PONum}</h4>}
                            { this.props.purchaseOrderEdited && this.props.currentPurchaseOrder && <h4><Translate value="msg_purchase_order_num_is" />: {this.props.currentPurchaseOrder.PONum}</h4>}
                            { this.props.purchaseOrderPlaced && this.props.currentPurchaseQuote && <h4><Translate value="msg_purchase_order_num_is" />: {this.props.currentPurchaseQuote.PONum}</h4>}
                          {/*   <h4><Translate value="msg_purchase_order_num_is" />: {(this.props.purchaseOrderCreated && this.props.purchaseOrderCreated.PONum) || (this.props.currentPurchaseOrder && this.props.currentPurchaseOrder.PONum)}</h4>*/}
                          </Row>
                          <br/>
                          <Row className="centerStyle"><h4><Translate value="msg_ask_if_stay_on_current_page" /></h4></Row>
                          <br/><br/>
                          <Row className="centerStyle">
                            <Button bsStyle="primary" onClick={(event) => {this.refreshPage(event)}} type="button" ><Translate value="yes" /></Button>
                            <Button bsStyle="danger" onClick={this.redirect} type="button" ><Translate value="no" /></Button>
                          </Row>
                      </SkyLightStateless>
                    </div>
                    {/* End PO Create Open */}
                    <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
                        <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} zeroArray={this.state.quantityZero}/>
                    </SkyLightStateless>

                    <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.changeTaxOpen} onCloseClicked={() => { this.closeChangeTax(); }} title={changeTax}>
                        <TaxSelectionModal taxRateOptions = {this.getTaxRateOptions()}/>
                    </SkyLightStateless>
                  </form> {/* Form Wrapper Makes Entire Page an Active Form */}
                </ContentWrapper>
                //---------------
                // End HTML
                //---------------
            )
        }
    }
}

export default withRouter(PurchaseOrderForm);

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseOrderForm.jsx